(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(57898);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GoogleOneTapSignIn; },
  "H": function() { return /* binding */ runWithGoogleAccountsId; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@elgorditosalsero/react-gtm-hook/dist/react-gtm-hook.esm.js
var react_gtm_hook_esm = __webpack_require__(94904);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(35764);
// EXTERNAL MODULE: ./lib/amplitude/Amplitude.tsx
var Amplitude = __webpack_require__(89514);
// EXTERNAL MODULE: ./lib/analytics/utm.ts
var utm = __webpack_require__(62625);
// EXTERNAL MODULE: ./lib/hooks/useSelfie.ts
var useSelfie = __webpack_require__(2254);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./lib/queries/auth/SignInWithGoogleOAuthIdTokenMutation.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SignInWithGoogleOAuthIdToken($idToken: String!) {\n    signInWithGoogleOAuthIdToken(idToken: $idToken) {\n      email\n      isRecentlyCreatedUser\n      accessToken\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SignInWithGoogleOAuthIdTokenMutation = ((0,lib/* default */.ZP)(_templateObject()));

// EXTERNAL MODULE: ./lib/utils/isBrowser.ts
var isBrowser = __webpack_require__(96007);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/auth/GoogleOneTapSignIn.tsx



/* eslint-disable react-hooks/exhaustive-deps */ 










function GoogleOneTapSignIn(param) {
    var redirectTo = param.redirectTo;
    var router = (0,next_router.useRouter)();
    var amplitude = (0,Amplitude/* useAmplitude */.iz)();
    var sendDataToGTM = (0,react_gtm_hook_esm/* useGTMDispatch */.PN)();
    var user = (0,useSelfie/* default */.Z)();
    var login = (0,react.useContext)(Auth/* AuthContext */.Vo).login;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(SignInWithGoogleOAuthIdTokenMutation, {
        refetchQueries: [],
        onCompleted: function(data) {
            if (data && data.signInWithGoogleOAuthIdToken) {
                if (data.signInWithGoogleOAuthIdToken.isRecentlyCreatedUser) {
                    amplitude.logEvent("Signed up", (0,_object_spread/* default */.Z)({
                        authentication: "google",
                        email: data.signInWithGoogleOAuthIdToken.email
                    }, (0,utm/* getUtmParametersFromParsedUrlQuery */.A)(router.query)));
                    sendDataToGTM({
                        event: "signedUp"
                    });
                }
                login(data.signInWithGoogleOAuthIdToken.accessToken);
                if (redirectTo && typeof redirectTo === "string") {
                    router.replace(redirectTo);
                } else if (redirectTo && typeof redirectTo === "object") {
                    router.replace(redirectTo.url, redirectTo.as);
                } else {
                    router.replace("/");
                }
                amplitude.logEvent("Signed in", (0,_object_spread/* default */.Z)({
                    method: "google",
                    email: data.signInWithGoogleOAuthIdToken.email
                }, (0,utm/* getUtmParametersFromParsedUrlQuery */.A)(router.query)));
            }
        }
    }), 1), signUpFromGoogleOAuthIdToken = ref[0];
    var promptListener = function(notification) {
        if (notification.isNotDisplayed()) {
            // Not a "wowzer" event name, but does the job of us tracking the reason for it not being displayed
            amplitude.logEvent("Google One Tap wasn't displayed", {
                reason: notification.getNotDisplayedReason()
            });
        }
    };
    (0,react.useEffect)(function() {
        runWithGoogleAccountsId(function(id) {
            if (user) {
                id.cancel();
            } else {
                id.prompt(promptListener);
            }
        });
        return function() {
            runWithGoogleAccountsId(function(id) {
                if (user) {
                    id.cancel();
                }
            });
        };
    }, [
        user
    ]);
    // See: https://developers.google.com/identity/gsi/web/guides/client-library
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
        id: "googleOneTap",
        async: true,
        defer: true,
        src: "https://accounts.google.com/gsi/client",
        onLoad: function() {
            runWithGoogleAccountsId(function(id) {
                id.initialize({
                    // See: https://developers.google.com/identity/gsi/web/guides/get-google-api-clientid
                    // See: https://developers.google.com/identity/gsi/web/reference/js-reference#IdConfiguration
                    client_id: "352739332472-smisa8k9l0pge4n5sc4srotm1muunh26.apps.googleusercontent.com",
                    cancel_on_tap_outside: false,
                    auto_select: false,
                    context: "signin",
                    callback: function(param) {
                        var credential = param.credential;
                        signUpFromGoogleOAuthIdToken({
                            variables: {
                                idToken: credential
                            }
                        });
                    }
                });
                id.prompt(promptListener);
            });
        }
    });
};
function runWithGoogleAccountsId(fn) {
    if ((0,isBrowser/* default */.Z)() && window && window.google && window.google.accounts && window.google.accounts.id && typeof window.google.accounts.id.initialize === "function" && typeof window.google.accounts.id.prompt === "function") {
        fn(window.google.accounts.id);
    }
}


/***/ }),

/***/ 51802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OverdueSubscriptionStickyBanner; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31132);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23855);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var types_graphqlTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84556);
/* harmony import */ var _lib_hooks_useSelfie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2254);





function OverdueSubscriptionStickyBanner() {
    var user = (0,_lib_hooks_useSelfie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (!user) {
        return null;
    }
    if (!user.subscription || user.subscription.status !== types_graphqlTypes__WEBPACK_IMPORTED_MODULE_1__/* .IStripeSubscriptionStatus.PastDue */ .gt.PastDue || !user.subscription.latestInvoice) {
        return null;
    }
    var nextPaymentAttempt = user.subscription.latestInvoice.nextPaymentAttempt;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        className: "px-6",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
            className: "m-auto mt-8 max-w-screen-legacyDesktop rounded-sm border-b-4 border-rose-600",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                className: "space-y-2 rounded-t-md bg-rose-100 p-4 font-aeonik shadow-sm",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h2", {
                                className: "text-lg font-bold text-rose-600",
                                children: "Fala Investidor!"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("p", {
                                className: "text-sm font-medium leading-6 tracking-wider text-rose-600",
                                children: [
                                    "...n\xe3o conseguimos realizar a cobran\xe7a da sua assinatura Premium no cart\xe3o. Por favor,",
                                    " ",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                                        href: "/billing/payment-methods",
                                        as: "/billing/payment-methods",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                                            href: "/billing/payment-methods",
                                            className: "text-blue-600 hover:underline",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: "clique aqui para atualizar os dados do seu cart\xe3o."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    nextPaymentAttempt && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("p", {
                        className: "text-md font-medium leading-6 tracking-wide text-rose-800",
                        children: [
                            "A pr\xf3xima tentativa de cobran\xe7a ser\xe1 em",
                            " ",
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("strong", {
                                className: "rounded-md bg-brand p-1 text-xs font-extrabold text-white",
                                children: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nextPaymentAttempt), "dd/MM")
                            }),
                            ". Regularize seu pagamento o quanto antes para continuar garantindo o seu acesso. Caso falte com o pagamento, seu acesso ser\xe1 cortado."
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 18098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FundamenteiWithText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var components_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19889);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);






function FundamenteiWithText(_param) {
    var fill = _param.fill, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "fill"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 716 124",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("g", {
            fill: fill || components_palette__WEBPACK_IMPORTED_MODULE_5__/* .royalBlue */ .VI,
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                    d: "M157.362 28.895h42.844v9.802H168.38v19.504h26.266v9.512H168.38v28.444h-11.028V28.895zM249.288 46.956v49.201h-9.108l-1.15-6.244c-3.71 4.55-8.759 6.825-15.148 6.825-5.749 0-10.418-1.794-13.998-5.382-3.58-3.588-5.369-9.35-5.369-17.299V46.956h10.348v26.039c0 4.8.96 8.459 2.88 10.955 1.92 2.495 4.76 3.748 8.529 3.748 3.96 0 7.059-1.453 9.298-4.37 2.24-2.916 3.36-6.905 3.36-11.967V46.956h10.358ZM299.561 51.757c3.67 3.588 5.51 9.351 5.51 17.299v27.101h-10.45v-26.52c0-4.68-.99-8.228-2.969-10.664-1.98-2.435-4.89-3.648-8.718-3.648-4.09 0-7.3 1.423-9.64 4.28-2.329 2.846-3.499 6.775-3.499 11.766v24.786h-10.348V46.956h9.009l1.15 6.435c3.709-4.681 8.948-7.016 15.717-7.016 5.81 0 10.559 1.794 14.238 5.382ZM362.101 28.895v67.252h-9.008l-1.25-7.397c-3.899 5.322-9.238 7.978-16.007 7.978-4.47 0-8.469-1.012-11.978-3.026-3.52-2.015-6.26-4.932-8.24-8.74-1.979-3.809-2.969-8.279-2.969-13.4 0-5.122 1.01-9.402 3.02-13.21 2.01-3.809 4.779-6.755 8.288-8.84 3.51-2.085 7.48-3.127 11.889-3.127 3.58 0 6.709.661 9.398 1.964 2.68 1.313 4.86 3.127 6.52 5.432V28.895H362.1Zm-24.536 26.31c-4.279 0-7.728 1.523-10.348 4.56-2.62 3.047-3.93 6.966-3.93 11.767 0 4.8 1.31 8.83 3.93 11.866 2.62 3.047 6.07 4.56 10.348 4.56 4.28 0 7.73-1.503 10.349-4.52v.02c2.62-3.006 3.93-6.915 3.93-11.726 0-4.81-1.31-8.92-3.93-11.967-2.62-3.037-6.07-4.56-10.349-4.56ZM393.367 46.365c6.58 0 11.659 1.533 15.238 4.61 3.58 3.077 5.37 7.497 5.37 13.26v19.414c0 2.305 1.09 3.458 3.259 3.458h2v9.03h-5.46c-3.2 0-5.499-.671-6.899-2.014-1.41-1.343-2.11-3.298-2.11-5.864-3.709 5.633-9.108 8.46-16.197 8.46-5.5 0-9.909-1.284-13.228-3.85-3.32-2.565-4.98-6.083-4.98-10.573 0-5.062 1.79-8.95 5.37-11.677 3.58-2.726 8.789-4.089 15.628-4.089h12.368v-2.976c0-2.757-.96-4.912-2.88-6.485-1.92-1.574-4.57-2.355-7.959-2.355-3 0-5.479.661-7.429 1.974-1.95 1.313-3.12 3.057-3.499 5.242H371.8c.51-4.931 2.68-8.76 6.52-11.486 3.829-2.726 8.848-4.08 15.047-4.08Zm10.329 27.863h-12.838c-3.2 0-5.66.621-7.38 1.874-1.729 1.253-2.589 3.087-2.589 5.522 0 2.115.81 3.809 2.44 5.092 1.63 1.283 3.85 1.924 6.659 1.924 4.28 0 7.619-1.152 10.018-3.458 2.4-2.305 3.63-5.382 3.69-9.22v-1.734ZM494.672 51.597c3.39 3.487 5.08 9.08 5.08 16.767v27.773h-10.349V68.465c0-4.29-.86-7.557-2.59-9.803-1.73-2.245-4.279-3.367-7.668-3.367-3.58 0-6.41 1.263-8.479 3.798-2.08 2.536-3.12 6.004-3.12 10.424v26.62h-10.448V68.465c0-4.36-.88-7.638-2.64-9.853-1.76-2.205-4.329-3.317-7.719-3.317-3.389 0-6.309 1.313-8.388 3.939-2.08 2.626-3.12 6.154-3.12 10.574v26.33h-10.348V46.935h9.008l1.15 6.435c3.51-4.61 8.309-6.946 14.378-7.016 3.45 0 6.49.741 9.109 2.205 2.62 1.473 4.63 3.718 6.039 6.725 1.73-2.817 3.99-5.011 6.809-6.585 2.81-1.574 6.199-2.355 10.158-2.355 5.37 0 9.749 1.744 13.128 5.231l.01.02ZM531.197 46.355c4.67 0 8.899.962 12.508 2.886 3.61 1.925 6.45 4.64 8.529 8.169 2.08 3.528 3.15 7.657 3.21 12.398 0 1.283-.1 2.595-.29 3.939h-37.005v.58c.25 4.29 1.6 7.688 4.03 10.184 2.43 2.495 5.659 3.748 9.678 3.748 3.2 0 5.88-.751 8.049-2.255 2.17-1.503 3.61-3.638 4.31-6.394h10.348c-.9 5.001-3.31 9.1-7.24 12.298-3.929 3.207-8.838 4.8-14.717 4.8-5.11 0-9.569-1.042-13.368-3.127-3.8-2.084-6.74-5.011-8.819-8.79-2.08-3.778-3.12-8.168-3.12-13.16 0-4.99 1.01-9.49 3.02-13.31h.02c2.01-3.808 4.82-6.755 8.439-8.84 3.61-2.084 7.749-3.126 12.418-3.126Zm.37 8.359c-3.39 0-6.309 1.042-8.769 3.127-2.46 2.084-3.88 4.85-4.269 8.308h26.366c-.45-3.588-1.87-6.394-4.27-8.409-2.399-2.014-5.418-3.026-9.058-3.026ZM603.896 51.737c3.67 3.588 5.51 9.35 5.51 17.299v27.101h-10.449v-26.52c0-4.68-.99-8.228-2.97-10.664-1.98-2.435-4.889-3.648-8.718-3.648-4.09 0-7.3 1.423-9.639 4.28-2.33 2.846-3.5 6.775-3.5 11.766v24.786h-10.348V46.936h9.009l1.15 6.435c3.71-4.681 8.949-7.016 15.718-7.016 5.809 0 10.558 1.794 14.237 5.382ZM621.964 56.057h-8.529v-9.131h8.529V33.185h10.448v13.741h11.789v9.13h-11.789v25.659c0 1.924.38 3.287 1.15 4.079.77.802 2.08 1.202 3.93 1.202h7.858v9.131h-9.968c-4.67 0-8.069-1.092-10.209-3.267-2.14-2.175-3.21-5.543-3.21-10.093v-26.71ZM671.916 46.345c4.67 0 8.9.962 12.509 2.886 3.61 1.925 6.449 4.64 8.528 8.169 2.08 3.528 3.15 7.657 3.21 12.398 0 1.283-.1 2.595-.29 3.939h-37.005v.58c.25 4.29 1.6 7.688 4.03 10.184 2.43 2.495 5.659 3.748 9.678 3.748 3.2 0 5.88-.751 8.05-2.255 2.169-1.503 3.609-3.638 4.309-6.394h10.348c-.9 5.001-3.31 9.1-7.239 12.298-3.93 3.207-8.839 4.8-14.718 4.8-5.109 0-9.568-1.042-13.368-3.127-3.8-2.084-6.739-5.011-8.818-8.79-2.08-3.778-3.12-8.168-3.12-13.16 0-4.99 1.01-9.49 3.02-13.31h.02c2.01-3.808 4.819-6.755 8.438-8.84 3.61-2.084 7.75-3.126 12.418-3.126Zm.37 8.359c-3.39 0-6.309 1.042-8.768 3.127-2.46 2.084-3.88 4.85-4.27 8.308h26.366c-.45-3.588-1.87-6.394-4.269-8.409-2.4-2.014-5.42-3.026-9.059-3.026ZM714.18 29.005c1.21 1.183 1.82 2.677 1.82 4.47 0 1.795-.61 3.288-1.82 4.47-1.22 1.183-2.72 1.775-4.51 1.775-1.789 0-3.289-.592-4.508-1.774-1.21-1.183-1.82-2.676-1.82-4.47 0-1.794.61-3.278 1.82-4.47 1.21-1.183 2.72-1.775 4.509-1.775 1.79 0 3.29.592 4.51 1.774ZM704.502 46.926h10.348v49.201h-10.348zM90.532.08 76.324 14.322l14.078 14.112c7.189 7.206 7.189 18.893 0 26.1L35.42 109.647 49.738 124l57.051-57.19c13.898-13.93 13.898-36.512 0-50.443L90.532.07v.01Z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                    d: "m26.681 123.92 14.208-14.242-14.078-14.112c-7.189-7.206-7.189-18.893 0-26.1l54.982-55.114L67.475 0 10.423 57.19c-13.897 13.93-13.897 36.512 0 50.443l16.258 16.297v-.01Z"
                })
            ]
        })
    }));
};


/***/ }),

/***/ 84544:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var FundamenteiWithTextSizingProps = {
    FULL_WIDTH: {
        width: 716,
        height: 124
    },
    HALF_WIDTH: {
        width: 358,
        height: 62
    },
    MEDIUM: {
        width: 260,
        height: 45
    },
    SMALL: {
        width: 200,
        height: 35
    },
    VERY_SMALL: {
        width: 180,
        height: 31
    }
};
var LogoSizingProps = {
    FundamenteiWithText: FundamenteiWithTextSizingProps
};
/* harmony default export */ __webpack_exports__["Z"] = (LogoSizingProps);


/***/ }),

/***/ 62045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureBox; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69864);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82911);
/* harmony import */ var lib_amplitude_Amplitude__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89514);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);




function FeatureBox(param) {
    var displayOrigin = param.displayOrigin, callToActionText = param.callToActionText, featureHighlights = param.featureHighlights, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Ver mais detalhes" : _buttonText;
    var amplitude = (0,lib_amplitude_Amplitude__WEBPACK_IMPORTED_MODULE_0__/* .useAmplitude */ .iz)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
        className: "bg-brand-50 flex w-full flex-col space-y-4 border-t border-t-slate-200 pt-4 font-aeonik font-normal",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
                className: "flex flex-col items-center space-y-1",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
                        className: "border-2 border-brand bg-brand/10 p-2 squircle",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            strokeWidth: 1.5,
                            className: "h-6 w-6 text-brand"
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("h2", {
                            className: "inline-flex px-4 py-1 text-xl font-bold italic tracking-wide text-brand",
                            children: "Premium"
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("em", {
                        className: "text-center text-sm tracking-wide text-gray-500",
                        children: callToActionText
                    })
                ]
            }),
            featureHighlights.length > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
                className: "space-y-2",
                children: [
                    featureHighlights.map(function(line) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("li", {
                            className: "flex items-center space-x-2",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
                                    className: "rounded-full bg-violet-100 p-1 text-violet-600",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        className: "h-3 w-3",
                                        strokeWidth: 3
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                                    className: "text-sm font-medium tracking-wide text-slate-700",
                                    children: line
                                })
                            ]
                        }, line);
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("p", {
                        className: "text-sm italic tracking-wide text-gray-500",
                        children: "...e muito mais!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/premium",
                as: "/premium",
                passHref: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("a", {
                    href: "/premium",
                    className: "rounded-full bg-brand p-2 text-center text-base font-medium text-white hover:bg-brand/80",
                    onClick: function() {
                        amplitude.logEvent("Click on link to become Premium", {
                            origin: displayOrigin
                        });
                    },
                    children: buttonText
                })
            })
        ]
    });
};


/***/ }),

/***/ 64376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BackToTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var lib_miolo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71019);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  20% {\n    transform: translateY(6px);\n  }\n  40% {\n    transform: translateY(-6px);\n  }\n  60% {\n    transform: translateY(4px);\n  }\n  80% {\n    transform: translateY(-2px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function BackToTop() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showScroll = ref[0], setShowScroll = ref[1];
    var checkScrollTop = function() {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true);
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false);
        }
    };
    var scrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", checkScrollTop);
        return function() {
            window.removeEventListener("scroll", checkScrollTop);
        };
    }, [
        showScroll
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        "aria-hidden": showScroll === false,
        style: {
            display: showScroll ? "flex" : "none"
        },
        css: {
            position: "fixed",
            right: 24,
            bottom: 24,
            zIndex: 3,
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("button", {
            type: "button",
            onClick: scrollTop,
            tabIndex: -1,
            "aria-label": "Voltar para o topo da p\xe1gina",
            css: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                margin: 0,
                padding: 0,
                color: lib_miolo__WEBPACK_IMPORTED_MODULE_2__/* .palette.white */ .DG.white,
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                border: "none",
                borderRadius: "100%",
                outline: "none",
                cursor: "pointer",
                appearance: "none",
                userSelect: "none",
                "&:hover": {
                    backgroundColor: lib_miolo__WEBPACK_IMPORTED_MODULE_2__/* .palette.royalBlue */ .DG.royalBlue,
                    boxShadow: "0 1px 8px 0 #33333366",
                    transition: "box-shadow 60ms ease 0s",
                    animation: "".concat(wiggle, " 1.2s ease"),
                    animationIterationCount: 1
                },
                WebkitAppearance: "none"
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ArrowUp, {
                width: 32,
                height: 32,
                display: "flex"
            })
        })
    });
};
function ArrowUp(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: 32,
        height: 32,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            d: "M12 19V5M5 12l7-7 7 7"
        })
    }));
}
var wiggle = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)(_templateObject());


/***/ }),

/***/ 6330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _palette__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19889);


function Divider(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "normal" : _variant;
    if (variant === "fade-to-right") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            "aria-hidden": true,
            css: {
                width: "100%",
                height: 1,
                opacity: 0.5,
                backgroundImage: "linear-gradient(to right, rgba(146, 167, 187, 0.4), rgba(0, 0, 0, 0))"
            }
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        "aria-hidden": true,
        css: {
            width: "100%",
            height: 1,
            borderBottom: variant === "normal" ? "solid 1px ".concat(_palette__WEBPACK_IMPORTED_MODULE_1__/* .mystic */ .Hc) : undefined,
            opacity: 0.5,
            backgroundImage: variant === "faded" ? "linear-gradient(to right, rgba(0, 0, 0, 0), ".concat(_palette__WEBPACK_IMPORTED_MODULE_1__/* .mystic */ .Hc, ", rgba(0, 0, 0, 0))") : undefined
        }
    });
};


/***/ }),

/***/ 3925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextTooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./components/palette.ts
var palette = __webpack_require__(19889);
// EXTERNAL MODULE: ./lib/miolo/index.ts + 26 modules
var miolo = __webpack_require__(71019);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(92261);
;// CONCATENATED MODULE: ./components/shared/Tooltip.tsx




function Tooltip(param) {
    var id = param.id, placement = param.placement, backgroundColor = param.backgroundColor, arrowColor = param.arrowColor, render = param.render, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* Popover */.J2, {
                id: id,
                isOpen: hovered,
                placement: placement,
                backgroundColor: backgroundColor,
                arrowColor: arrowColor,
                render: render,
                containerStyle: {
                    zIndex: 11
                },
                children: function(param) {
                    var accessibility = param.accessibility, ref = param.ref;
                    return children({
                        accessibility: accessibility,
                        ref: ref,
                        bind: bind
                    });
                }
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/shared/TextTooltip.tsx






function TextTooltip(_param) {
    var content = _param.content, contentClassName = _param.contentClassName, className = _param.className, style = _param.style, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "content",
        "contentClassName",
        "className",
        "style",
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        backgroundColor: palette/* mineShaft */.KY,
        arrowColor: palette/* mineShaft */.KY,
        render: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: className || contentClassName,
                css: (0,_object_spread/* default */.Z)({
                    display: "flex",
                    padding: "4px 8px",
                    color: palette/* white */.ix,
                    fontWeight: 500,
                    fontSize: 13,
                    lineHeight: 1.33,
                    letterSpacing: 0.8
                }, css),
                style: style,
                children: typeof content === "string" ? content : content()
            });
        }
    }));
};


/***/ }),

/***/ 95773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TwoPassRender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function TwoPassRender(param) {
    var children = param.children, loading = param.loading;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isClient = ref[0], setIsClient = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsClient(typeof document !== "undefined");
    }, []);
    if (isClient) {
        return children(document);
    }
    return loading ? loading() : null;
};


/***/ }),

/***/ 14501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WholePageLoadingBlankslate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils_getBaseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89288);
/* harmony import */ var _branding_Fundamentei__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75027);
/* harmony import */ var _palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19889);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          html,\n          body {\n            height: 100%;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function WholePageLoadingBlankslate() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), tryToRefreshManually = ref[0], setShowTryToRefreshManually = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var tryToRefreshManuallyTimeout = setTimeout(function() {
            return setShowTryToRefreshManually(true);
        }, 6000);
        return function() {
            return clearTimeout(tryToRefreshManuallyTimeout);
        };
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .Global */ .xB, {
                styles: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject())
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    backgroundColor: _palette__WEBPACK_IMPORTED_MODULE_5__/* .selago */ .Ow
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 18,
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_branding_Fundamentei__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                width: 106,
                                height: 101,
                                fill: _palette__WEBPACK_IMPORTED_MODULE_5__/* .royalBlue */ .VI
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h1", {
                            css: {
                                margin: 0,
                                color: _palette__WEBPACK_IMPORTED_MODULE_5__/* .royalBlue */ .VI,
                                fontWeight: "bold"
                            },
                            children: tryToRefreshManually ? "Aguarde :(" : "Aguarde..."
                        }),
                        tryToRefreshManually && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("p", {
                            css: {
                                margin: 0,
                                color: _palette__WEBPACK_IMPORTED_MODULE_5__/* .blueBayoux */ .xS,
                                fontWeight: 500,
                                fontSize: 16,
                                lineHeight: 1.33,
                                letterSpacing: 1
                            },
                            children: [
                                "Investidor\u2014caso essa p\xe1gina permane\xe7a por muito tempo, ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                                    title: "Atualizar p\xe1gina",
                                    href: (0,_lib_utils_getBaseUrl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(),
                                    css: {
                                        textDecoration: "underscore",
                                        color: _palette__WEBPACK_IMPORTED_MODULE_5__/* .link */ .p4
                                    },
                                    children: "tente atualizar manualmente."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 89922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMoneyValue; }
/* harmony export */ });
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

function formatMoneyValue(value) {
    var display = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "long", locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "pt-BR";
    try {
        var formatter = new Intl.NumberFormat(locale, {
            // @ts-ignore
            notation: "compact",
            compactDisplay: display,
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
        });
        return formatter.format(value).replace(/mil$/, "k").replace(/bi$/, "b").replace(/mi$/, "m").replace(/\s/, "");
    } catch (err) {
        return numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).format("0a");
    }
};


/***/ }),

/***/ 62625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getUtmParametersFromParsedUrlQuery; }
/* harmony export */ });
/* unused harmony export getUtmParametersFromUrl */
/* harmony import */ var lib_utils_stripUndefined__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52139);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);


// UTM parameters. See: https://en.wikipedia.org/wiki/UTM_parameters
var UTM_SOURCE = "utm_source";
var UTM_MEDIUM = "utm_medium";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_TERM = "utm_term";
var UTM_CONTENT = "utm_content";
function getUtmParametersFromUrl(rawUrl) {
    var url = new URL(rawUrl);
    return stripUndefined({
        utmSource: url.searchParams.get(UTM_SOURCE),
        utmMedium: url.searchParams.get(UTM_MEDIUM),
        utmCampaign: url.searchParams.get(UTM_CAMPAIGN),
        utmTerm: url.searchParams.get(UTM_TERM),
        utmContent: url.searchParams.get(UTM_CONTENT)
    });
}
function getUtmParametersFromParsedUrlQuery(query) {
    return (0,lib_utils_stripUndefined__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        utmSource: firstOrNull((0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(query, UTM_SOURCE)),
        utmMedium: firstOrNull((0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(query, UTM_MEDIUM)),
        utmCampaign: firstOrNull((0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(query, UTM_CAMPAIGN)),
        utmTerm: firstOrNull((0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(query, UTM_TERM)),
        utmContent: firstOrNull((0,lodash__WEBPACK_IMPORTED_MODULE_1__.get)(query, UTM_CONTENT))
    });
}
function firstOrNull(input) {
    if (!input) {
        return null;
    }
    if (Array.isArray(input)) {
        return input[0] || null;
    }
    return input;
}


/***/ }),

/***/ 74461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var facepaint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9401);

// See: https://tailwindcss.com/docs/responsive-design
var mediaQueries = (0,facepaint__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
    "@media (min-width: 640px)",
    "@media (min-width: 768px)",
    "@media (min-width: 1024px)",
    "@media (min-width: 1280px)",
    "@media (min-width: 1536px)", 
]);
/* harmony default export */ __webpack_exports__["Z"] = (mediaQueries);


/***/ }),

/***/ 57898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./lib/utils/getBaseUrl.ts
var getBaseUrl = __webpack_require__(89288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/advertisements/WorkshopCaixaPretaFundamentei.tsx




/* eslint-disable react/jsx-curly-brace-presence */ /* eslint-disable jsx-a11y/accessible-emoji */ 


function WorkshopCaixaPretaFundamentei(_param) {
    var popUpTitle = _param.popUpTitle, externalLinkText = _param.externalLinkText, externalLinkHref = _param.externalLinkHref, children = _param.children, onClose = _param.onClose, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "popUpTitle",
        "externalLinkText",
        "externalLinkHref",
        "children",
        "onClose",
        "className"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "px-6 xl:p-0",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: (0,clsx_m/* default */.Z)("relative rounded-md py-6 px-6 font-aeonik", "bg-gradient-to-r from-[#3f5fe9] to-red-500/90", "sm:rounded-xl sm:shadow-lg", className)
        }, props), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "relative space-y-4",
                    children: [
                        popUpTitle,
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex flex-col items-center space-y-4 sm:flex-row sm:space-y-0 sm:space-x-2",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "text-sm font-normal leading-6 tracking-wide text-white md:text-base",
                                    children: children
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    href: externalLinkHref,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: (0,clsx_m/* default */.Z)("flex w-full items-center justify-center whitespace-nowrap rounded-md bg-white py-3 px-12 text-xs", "font-semibold uppercase tracking-wider text-orange-700 shadow-sm md:w-auto md:text-xs", "hover:border-solid hover:bg-orange-100 hover:text-orange-700 hover:drop-shadow-sm"),
                                    children: externalLinkText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex items-center space-x-2",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "".concat((0,getBaseUrl/* default */.Z)(), "/static/people/eduardo.jpg"),
                                    alt: "Eduardo Cavalcanti",
                                    className: "h-8 w-8 rounded-3xl md:h-12 md:w-12",
                                    width: 48,
                                    height: 48
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "text-white",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                            className: "text-sm font-semibold drop-shadow-2xl md:text-sm",
                                            children: "Eduardo Cavalcanti"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            className: "text-[10px] font-normal italic tracking-wide text-gray-200 md:text-xs",
                                            children: "Cofundador do Fundamentei"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "absolute top-0 right-0 -m-3",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        type: "button",
                        "aria-label": "Fechar",
                        onClick: function() {
                            return onClose();
                        },
                        className: "cursor-pointer rounded-full bg-red-500 p-1 text-white shadow-lg hover:bg-red-400",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-4 w-4",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            strokeWidth: 3,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M6 18L18 6M6 6l12 12"
                            })
                        })
                    })
                })
            ]
        }))
    });
};

// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(35764);
// EXTERNAL MODULE: ./components/billing/OverdueSubscriptionStickyBanner.tsx
var OverdueSubscriptionStickyBanner = __webpack_require__(51802);
// EXTERNAL MODULE: ./components/auth/GoogleOneTapSignIn.tsx + 1 modules
var GoogleOneTapSignIn = __webpack_require__(5116);
// EXTERNAL MODULE: ./lib/miolo/index.ts + 26 modules
var miolo = __webpack_require__(71019);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getYear/index.js
var getYear = __webpack_require__(95570);
// EXTERNAL MODULE: ./lib/utils/layout/mediaQueries.ts
var mediaQueries = __webpack_require__(74461);
;// CONCATENATED MODULE: ./components/landing/Disclaimers.tsx

/* eslint-disable react/no-unescaped-entities */ 


function Disclaimers() {
    var copyright = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        children: [
            "\xa9 ",
            (0,getYear/* default */.Z)(new Date())
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
        css: (0,mediaQueries/* default */.Z)({
            display: "grid",
            gridRowGap: 30,
            gridColumnGap: 30,
            gridTemplateColumns: [
                "1fr",
                "1fr",
                "1fr",
                "1fr"
            ],
            justifyContent: "center",
            width: [
                null,
                null,
                null,
                "100%"
            ],
            maxWidth: 1140,
            margin: "0px auto",
            padding: [
                "0px 30px",
                0,
                0,
                0
            ],
            textAlign: [
                "center",
                "center",
                "left"
            ]
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
            css: {
                margin: 0,
                color: miolo/* shades.greys.variants.4 */.TE.greys.variants[4],
                fontWeight: 500,
                fontSize: 13,
                letterSpacing: 0.8,
                lineHeight: 1.66
            },
            children: [
                "Disclaimers: ",
                copyright,
                ' Morningstar - Os dados fundamentalistas e cota\xe7\xf5es de empresas Americanas ("Stocks") s\xe3o fornecidos pela Morningstar, atualizados diariamente. Cota\xe7\xf5es de ativos Brasileiros s\xe3o fornecidos pela',
                " ",
                copyright,
                " Enfoque Informa\xe7\xf5es Financeiras LTDA, atualizados diariamente. Dados de moedas (Forex) s\xe3o fornecidos pela ",
                copyright,
                ' apilayer Data Products GmbH ("Currencylayer"), atualizados diariamente. Outros dados embutidos nas p\xe1ginas das empresas tem origem direta dos sistemas dos \xf3rg\xe3os regulat\xf3rios como CVM ("Comiss\xe3o de Valores Mobili\xe1rios") / SEC ("U.S. Securities and Exchange Commission"), como tamb\xe9m podem ser obtidos de comunicados oficiais das empresas em quest\xe3o. O Fundamentei n\xe3o se responsabiliza pela precis\xe3o/completude ou integridade das informa\xe7\xf5es apresentadas no site ou em qualquer um de seus produtos. O Fundamentei tamb\xe9m n\xe3o se responsabiliza por quaisquer danos ou preju\xedzos decorrentes do uso dessas informa\xe7\xf5es.'
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/palette.ts
var palette = __webpack_require__(19889);
// EXTERNAL MODULE: ./components/branding/Fundamentei.tsx
var Fundamentei = __webpack_require__(75027);
;// CONCATENATED MODULE: ./components/landing/Footer.tsx










function Footer() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("footer", {
        css: (0,mediaQueries/* default */.Z)({
            display: "grid",
            gridRowGap: 30,
            gridColumnGap: 30,
            gridTemplateColumns: [
                "1fr",
                "1fr",
                "1fr",
                "repeat(12, 1fr)"
            ],
            justifyContent: "center",
            width: [
                null,
                null,
                null,
                "100%"
            ],
            maxWidth: 1140,
            margin: "0px auto",
            padding: [
                "0px 30px",
                0,
                0,
                0
            ],
            textAlign: [
                "center",
                "center",
                "left"
            ]
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    display: "grid",
                    gridRowGap: 48,
                    gridColumn: [
                        null,
                        null,
                        null,
                        "span 10"
                    ],
                    gridColumnGap: 48,
                    gridTemplateColumns: [
                        "100%",
                        "100%",
                        "repeat(4, max-content)",
                        "repeat(4, max-content)"
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 16
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                                    css: {
                                        margin: 0,
                                        color: palette/* blueBayoux */.xS,
                                        fontWeight: "bold",
                                        fontSize: 14,
                                        letterSpacing: 0.6,
                                        textTransform: "uppercase"
                                    },
                                    children: "Links"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                                        css: {
                                            display: "grid",
                                            gridRowGap: 16,
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/premium",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                        href: "/premium",
                                                        style: {
                                                            color: palette/* lynch */.Lr,
                                                            fontWeight: 500,
                                                            fontSize: 14,
                                                            letterSpacing: 0.6
                                                        },
                                                        children: "Premium"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/fatos-relevantes",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                        href: "/fatos-relevantes",
                                                        style: {
                                                            color: palette/* lynch */.Lr,
                                                            fontWeight: 500,
                                                            fontSize: 14,
                                                            letterSpacing: 0.6
                                                        },
                                                        children: "Fatos Relevantes"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/events-calendar",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                        href: "/events-calendar",
                                                        style: {
                                                            color: palette/* lynch */.Lr,
                                                            fontWeight: 500,
                                                            fontSize: 14,
                                                            letterSpacing: 0.6
                                                        },
                                                        children: "Agenda"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                    href: "mailto:contato@fundamentei.com",
                                                    style: {
                                                        color: palette/* lynch */.Lr,
                                                        fontWeight: 500,
                                                        fontSize: 14,
                                                        letterSpacing: 0.6
                                                    },
                                                    children: "Contato"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/privacy",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                        href: "/privacy",
                                                        style: {
                                                            color: palette/* lynch */.Lr,
                                                            fontWeight: 500,
                                                            fontSize: 14,
                                                            letterSpacing: 0.6
                                                        },
                                                        children: "Privacidade"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/payments-and-refunds",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                        href: "/payments-and-refunds",
                                                        style: {
                                                            color: palette/* lynch */.Lr,
                                                            fontWeight: 500,
                                                            fontSize: 14,
                                                            letterSpacing: 0.6
                                                        },
                                                        children: "Pagamentos & reembolsos"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/terms",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                        href: "/terms",
                                                        style: {
                                                            fontSize: 14,
                                                            letterSpacing: 0.6,
                                                            color: palette/* lynch */.Lr,
                                                            fontWeight: 500
                                                        },
                                                        children: "Termos de Uso"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 16
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                                    css: {
                                        margin: 0,
                                        color: palette/* blueBayoux */.xS,
                                        fontWeight: "bold",
                                        fontSize: 14,
                                        letterSpacing: 0.6,
                                        textTransform: "uppercase"
                                    },
                                    children: "A Empresa"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                                        css: {
                                            display: "grid",
                                            gridRowGap: 16,
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                    rel: "noopener noreferrer",
                                                    target: "_blank",
                                                    href: "https://medium.com/@fundamentei",
                                                    style: {
                                                        fontSize: 14,
                                                        letterSpacing: 0.6,
                                                        color: palette/* lynch */.Lr,
                                                        fontWeight: 500
                                                    },
                                                    children: "Blog"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                    rel: "noopener noreferrer",
                                                    target: "_blank",
                                                    href: "https://changelog.fundamentei.com",
                                                    style: {
                                                        fontSize: 14,
                                                        letterSpacing: 0.6,
                                                        color: palette/* lynch */.Lr,
                                                        fontWeight: 500
                                                    },
                                                    children: "Novidades"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 16
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                                    css: {
                                        margin: 0,
                                        color: palette/* blueBayoux */.xS,
                                        fontWeight: "bold",
                                        fontSize: 14,
                                        letterSpacing: 0.6,
                                        textTransform: "uppercase"
                                    },
                                    children: "Desenvolvedores"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                                        css: {
                                            display: "grid",
                                            gridRowGap: 16,
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                    rel: "noopener noreferrer",
                                                    target: "_blank",
                                                    href: "https://github.com/fundamentei",
                                                    style: {
                                                        fontSize: 14,
                                                        letterSpacing: 0.6,
                                                        color: palette/* lynch */.Lr,
                                                        fontWeight: 500
                                                    },
                                                    children: "GitHub"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                                    rel: "noopener noreferrer",
                                                    target: "_blank",
                                                    href: "https://stackshare.io/fundamentei/fundamentei",
                                                    style: {
                                                        fontSize: 14,
                                                        letterSpacing: 0.6,
                                                        color: palette/* lynch */.Lr,
                                                        fontWeight: 500
                                                    },
                                                    children: "StackShare"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 16
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                                    css: {
                                        margin: 0,
                                        color: palette/* blueBayoux */.xS,
                                        fontWeight: "bold",
                                        fontSize: 14,
                                        letterSpacing: 0.6,
                                        textTransform: "uppercase"
                                    },
                                    children: "Nas Redes Sociais"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                                        css: (0,mediaQueries/* default */.Z)({
                                            display: "grid",
                                            gridRowGap: 24,
                                            gridColumnGap: 24,
                                            gridTemplateColumns: [
                                                "repeat(3, max-content)",
                                                "repeat(3, max-content)",
                                                "repeat(3, max-content)",
                                                "repeat(5, max-content)", 
                                            ],
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    href: "https://www.youtube.com/channel/UC72WcGU4HpVposjNHlP3FRg",
                                                    title: "YouTube",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    css: {
                                                        color: palette/* baliHai */.r,
                                                        textDecoration: "none",
                                                        "&:hover": {
                                                            color: "#E93323"
                                                        },
                                                        "&:focus": {
                                                            color: "#E93323",
                                                            outline: "none"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YouTube, {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    href: "https://instagram.com/fundamentei",
                                                    title: "Instagram",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    css: {
                                                        color: palette/* baliHai */.r,
                                                        textDecoration: "none",
                                                        "&:hover": {
                                                            color: "#000000"
                                                        },
                                                        "&:focus": {
                                                            color: "#000000",
                                                            outline: "none"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Instagram, {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    href: "https://www.facebook.com/consultoreduardocavalcanti",
                                                    title: "Facebook",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    css: {
                                                        color: palette/* baliHai */.r,
                                                        textDecoration: "none",
                                                        "&:hover": {
                                                            color: "#3878EA"
                                                        },
                                                        "&:focus": {
                                                            color: "#3878EA",
                                                            outline: "none"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Facebook, {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    href: "https://twitter.com/fundamentei",
                                                    title: "Twitter",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    css: {
                                                        color: palette/* baliHai */.r,
                                                        textDecoration: "none",
                                                        "&:hover": {
                                                            color: "#4DA0EB"
                                                        },
                                                        "&:focus": {
                                                            color: "#4DA0EB",
                                                            outline: "none"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Twitter, {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    href: "https://www.linkedin.com/company/fundamentei",
                                                    title: "LinkedIn",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    css: {
                                                        color: palette/* baliHai */.r,
                                                        textDecoration: "none",
                                                        "&:hover": {
                                                            color: "#3376B0"
                                                        },
                                                        "&:focus": {
                                                            color: "#3376B0",
                                                            outline: "none"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedIn, {})
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    gridColumn: [
                        null,
                        null,
                        null,
                        "span 2"
                    ]
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 16,
                        gridTemplateColumns: "1fr",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: "/",
                                "aria-label": "P\xe1gina inicial",
                                css: {
                                    color: palette/* heather */.yx,
                                    "&:hover": {
                                        color: palette/* royalBlue */.VI
                                    },
                                    "&:focus": {
                                        outline: "none"
                                    }
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Fundamentei/* default */.Z, {
                                    fill: "currentColor",
                                    width: 39,
                                    height: 37
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                css: {
                                    color: palette/* baliHai */.r,
                                    fontWeight: 500,
                                    fontSize: 14,
                                    letterSpacing: 0.6
                                },
                                children: [
                                    "\xa9 ",
                                    (0,getYear/* default */.Z)(new Date()),
                                    " Fundamentei"
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
function YouTube(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 45,
        height: 32
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M44.06 5.007c-.518-1.97-2.043-3.523-3.979-4.05C36.571 0 22.5 0 22.5 0S8.428 0 4.919.957c-1.936.527-3.461 2.08-3.979 4.05C0 8.579 0 16.032 0 16.032s0 7.453.94 11.026c.518 1.97 2.043 3.458 3.979 3.985C8.429 32 22.5 32 22.5 32s14.072 0 17.581-.957c1.936-.527 3.461-2.014 3.979-3.985.94-3.573.94-11.026.94-11.026s0-7.453-.94-11.025zM18 23V10l12 6.5L18 23z"
        })
    }));
}
function Instagram(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 32,
        height: 32
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M16.004 7.796A8.19 8.19 0 007.8 16a8.19 8.19 0 008.203 8.204A8.19 8.19 0 0024.206 16a8.19 8.19 0 00-8.202-8.204zm0 13.538A5.343 5.343 0 0110.67 16a5.338 5.338 0 015.333-5.334A5.338 5.338 0 0121.336 16a5.343 5.343 0 01-5.332 5.334zM26.454 7.46a1.909 1.909 0 01-1.912 1.914 1.914 1.914 0 111.913-1.914zm5.434 1.942c-.122-2.563-.707-4.834-2.585-6.705C27.433.827 25.163.241 22.6.112c-2.641-.15-10.559-.15-13.2 0C6.844.234 4.574.82 2.697 2.69.819 4.561.24 6.832.112 9.395c-.15 2.642-.15 10.56 0 13.203.122 2.563.707 4.834 2.585 6.705 1.877 1.87 4.14 2.456 6.703 2.585 2.641.15 10.559.15 13.2 0 2.563-.122 4.833-.707 6.703-2.585 1.87-1.871 2.456-4.142 2.585-6.705.15-2.642.15-10.554 0-13.196zm-3.413 16.03a5.4 5.4 0 01-3.041 3.042c-2.106.836-7.103.643-9.43.643-2.328 0-7.332.186-9.43-.643a5.4 5.4 0 01-3.042-3.041c-.835-2.107-.643-7.105-.643-9.433 0-2.328-.185-7.333.643-9.433a5.4 5.4 0 013.041-3.041c2.106-.836 7.103-.643 9.43-.643 2.328 0 7.332-.186 9.431.643a5.4 5.4 0 013.041 3.041c.835 2.107.643 7.105.643 9.433 0 2.328.192 7.333-.643 9.433z"
        })
    }));
}
function Facebook(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 32,
        height: 32
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M32 16.097C32 7.205 24.839 0 16 0S0 7.205 0 16.097C0 24.132 5.851 30.791 13.5 32V20.75H9.435v-4.653H13.5v-3.546c0-4.034 2.387-6.263 6.043-6.263 1.751 0 3.582.315 3.582.315v3.959h-2.018c-1.987 0-2.607 1.241-2.607 2.514v3.021h4.437l-.71 4.654H18.5V32C26.149 30.791 32 24.132 32 16.097z"
        })
    }));
}
function Twitter(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 32,
        height: 32
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M28.571 0H3.43A3.43 3.43 0 000 3.429V28.57A3.43 3.43 0 003.429 32H28.57A3.43 3.43 0 0032 28.571V3.43A3.43 3.43 0 0028.571 0zM25.08 11.343c.014.2.014.407.014.607 0 6.193-4.714 13.329-13.329 13.329-2.657 0-5.121-.772-7.193-2.1a9.87 9.87 0 001.129.057 9.392 9.392 0 005.814-2 4.69 4.69 0 01-4.378-3.25c.721.107 1.371.107 2.114-.086a4.685 4.685 0 01-3.75-4.6v-.057c.621.35 1.35.564 2.114.593a4.675 4.675 0 01-2.085-3.9c0-.872.228-1.672.635-2.365a13.302 13.302 0 009.657 4.9c-.664-3.178 1.715-5.757 4.572-5.757 1.35 0 2.564.565 3.421 1.479a9.18 9.18 0 002.972-1.129 4.672 4.672 0 01-2.057 2.579 9.323 9.323 0 002.7-.729 9.86 9.86 0 01-2.35 2.429z"
        })
    }));
}
function LinkedIn(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 32,
        height: 32
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M29.714 0H2.28C1.02 0 0 1.036 0 2.307v27.386C0 30.964 1.021 32 2.279 32h27.435C30.971 32 32 30.964 32 29.693V2.307C32 1.036 30.971 0 29.714 0zM9.671 27.429H4.93V12.157h4.75V27.43H9.67zM7.3 10.07a2.751 2.751 0 010-5.5 2.756 2.756 0 012.75 2.75 2.747 2.747 0 01-2.75 2.75zM27.45 27.43h-4.743V20c0-1.771-.036-4.05-2.464-4.05-2.472 0-2.85 1.929-2.85 3.921v7.558H12.65V12.157h4.55v2.086h.064c.636-1.2 2.186-2.464 4.493-2.464 4.8 0 5.693 3.164 5.693 7.278v8.372z",
            fillRule: "nonzero"
        })
    }));
}

// EXTERNAL MODULE: ./components/branding/FundamenteiWithText.tsx
var FundamenteiWithText = __webpack_require__(18098);
// EXTERNAL MODULE: ./components/branding/LogoSizingProps.ts
var LogoSizingProps = __webpack_require__(84544);
;// CONCATENATED MODULE: ./components/landing/Header.tsx








function Header() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("header", {
        css: (0,mediaQueries/* default */.Z)({
            display: "grid",
            gridColumnGap: 30,
            gridRowGap: 30,
            gridTemplateColumns: [
                "1fr",
                "max-content 1fr",
                "max-content 1fr",
                "max-content 1fr"
            ],
            alignItems: "center",
            justifyContent: "center",
            maxWidth: 1140,
            padding: [
                "0 30px",
                null,
                null,
                null
            ],
            textAlign: [
                "center",
                "left",
                "left",
                "left"
            ]
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    href: "/",
                    title: "Fundamentei",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundamenteiWithText/* default */.Z, (0,_object_spread/* default */.Z)({
                        className: "inline-flex"
                    }, LogoSizingProps/* default.FundamenteiWithText.VERY_SMALL */.Z.FundamenteiWithText.VERY_SMALL))
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
                css: (0,mediaQueries/* default */.Z)({
                    display: "grid",
                    gridRowGap: 30,
                    gridColumnGap: 30,
                    gridTemplateColumns: [
                        "max-content",
                        "repeat(2, max-content)",
                        "repeat(2, max-content)",
                        "repeat(2, max-content)", 
                    ],
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: [
                        0,
                        "auto",
                        "auto",
                        "auto"
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/login",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkAnchorButton */.nM, {
                                href: "/login",
                                style: {
                                    fontSize: 16,
                                    fontWeight: 500,
                                    lineHeight: 1.33,
                                    letterSpacing: 1.6
                                },
                                children: "Login"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/sign-up",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: "/sign-up",
                            css: {
                                display: "inline-block",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: "8px 16px",
                                overflow: "visible",
                                color: palette/* mariner */.Mw,
                                fontWeight: 500,
                                fontSize: 16,
                                lineHeight: 1.33,
                                textDecoration: "none",
                                border: "solid 1px ".concat(palette/* mariner */.Mw),
                                borderRadius: 20,
                                transition: "all 60ms ease 0s",
                                userSelect: "none",
                                "&:hover": {
                                    color: palette/* white */.ix,
                                    backgroundColor: palette/* mariner */.Mw
                                },
                                "&:focus": {
                                    outline: "none",
                                    boxShadow: "".concat(palette/* tropicalBlue */.sB, " 0px 0px 0px 3px")
                                },
                                "&:active": {
                                    boxShadow: "transparent 0px 0px 0px 0px"
                                },
                                WebkitAppearance: "none"
                            },
                            children: "Cadastre-se"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/landing/Landing.tsx












function Landing() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            padding: "32px 0px"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleOneTapSignIn/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    maxWidth: 1140,
                    margin: "0px auto"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
                css: {
                    marginTop: 30,
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gridRowGap: 36
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
                        css: (0,mediaQueries/* default */.Z)({
                            position: "relative",
                            "&:before": {
                                position: "absolute",
                                top: 0,
                                right: 0,
                                left: 0,
                                zIndex: -1,
                                width: "100%",
                                height: "100%",
                                backgroundColor: palette/* mariner */.Mw,
                                content: '""',
                                clipPath: "polygon(0 0, 100% 0%, 100% 100%, 0 70%)"
                            }
                        }),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: (0,mediaQueries/* default */.Z)({
                                display: "grid",
                                gridColumnGap: 30,
                                gridTemplateColumns: [
                                    "1fr",
                                    "1fr",
                                    "1fr",
                                    "repeat(12, 1fr)"
                                ],
                                justifyContent: "center",
                                padding: [
                                    "0px 30px",
                                    "0px 30px",
                                    "0px 30px",
                                    0
                                ],
                                maxWidth: 1140,
                                margin: "0px auto"
                            }),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: (0,mediaQueries/* default */.Z)({
                                        gridColumn: "span 6",
                                        padding: "36px 0px",
                                        display: "grid",
                                        gridRowGap: 28,
                                        textAlign: [
                                            "center",
                                            "center",
                                            "center",
                                            "left"
                                        ]
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                display: "grid",
                                                gridTemplateColumns: "repeat(6, 1fr)"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                css: (0,mediaQueries/* default */.Z)({
                                                    gridColumn: [
                                                        "span 6",
                                                        "span 6",
                                                        "span 6",
                                                        "span 5"
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                                    css: (0,mediaQueries/* default */.Z)({
                                                        margin: 0,
                                                        color: palette/* white */.ix,
                                                        fontWeight: [
                                                            900,
                                                            900,
                                                            900,
                                                            900
                                                        ],
                                                        fontSize: [
                                                            18,
                                                            18,
                                                            18,
                                                            21
                                                        ],
                                                        lineHeight: 1.33,
                                                        letterSpacing: 1,
                                                        textTransform: "uppercase"
                                                    }),
                                                    children: "An\xe1lise Fundamentalista de A\xe7\xf5es, Stocks e Fundos Imobili\xe1rios"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            css: (0,mediaQueries/* default */.Z)({
                                                color: palette/* white */.ix,
                                                fontWeight: 300,
                                                fontSize: [
                                                    14,
                                                    14,
                                                    14,
                                                    16
                                                ],
                                                lineHeight: 1.66,
                                                letterSpacing: 1,
                                                margin: 0
                                            }),
                                            children: "Site completo com acesso imediato a mais de 5.000 ativos, indispens\xe1vel para investidores que aplicam o Buy&Hold!"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                display: "grid",
                                                gridTemplateColumns: "repeat(6, 1fr)"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                css: (0,mediaQueries/* default */.Z)({
                                                    gridColumn: [
                                                        "span 6",
                                                        "span 6",
                                                        "span 6",
                                                        "span 4"
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/sign-up",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                        href: "/sign-up",
                                                        css: {
                                                            display: "inline-block",
                                                            boxSizing: "border-box",
                                                            width: "100%",
                                                            margin: 0,
                                                            padding: "12px 0px",
                                                            overflow: "visible",
                                                            color: palette/* white */.ix,
                                                            fontWeight: 500,
                                                            fontSize: 14,
                                                            lineHeight: 1.33,
                                                            letterSpacing: 1,
                                                            textAlign: "center",
                                                            textTransform: "uppercase",
                                                            textDecoration: "none",
                                                            backgroundColor: palette/* keppel */.v7,
                                                            borderRadius: 28,
                                                            boxShadow: "rgba(78, 101, 127, 0.5) 0px 8px 24px 0px",
                                                            transition: "all 60ms ease 0s",
                                                            userSelect: "none",
                                                            "&:hover, &:focus": {
                                                                backgroundColor: palette/* downy */.BQ,
                                                                outline: "none"
                                                            },
                                                            WebkitAppearance: "none"
                                                        },
                                                        children: "Quero me Cadastrar"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: (0,mediaQueries/* default */.Z)({
                                        display: [
                                            "none",
                                            "none",
                                            "none",
                                            "block"
                                        ],
                                        position: "relative",
                                        gridColumn: "span 6"
                                    }),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            position: "absolute",
                                            top: -24,
                                            left: 0,
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                            alt: "Fundamentei",
                                            draggable: false,
                                            onContextMenu: function(event) {
                                                return event.preventDefault();
                                            },
                                            onMouseDown: function(event) {
                                                return event.preventDefault();
                                            },
                                            role: "presentation",
                                            src: "/static/app-illustrations--screener.svg",
                                            css: {
                                                userSelect: "none",
                                                position: "relative",
                                                maxHeight: 364
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFeatures, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhoAreWe, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                        css: {
                            width: "100%",
                            maxWidth: 1140,
                            margin: "0px auto",
                            border: "none",
                            borderBottom: "solid 2px ".concat(palette/* mystic */.Hc)
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                        css: {
                            width: "100%",
                            maxWidth: 1140,
                            margin: "0px auto",
                            border: "none",
                            borderBottom: "solid 2px ".concat(palette/* mystic */.Hc)
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimers, {})
                ]
            })
        ]
    });
};
function KeyFeature(param) {
    var feature = param.feature, description = param.description;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: (0,mediaQueries/* default */.Z)({
            display: "grid",
            gridTemplateColumns: [
                "auto-fit",
                "auto-fit",
                "auto-fit",
                "max-content 1fr"
            ],
            gridColumnGap: 30,
            gridRowGap: 30,
            padding: [
                "0px 30px",
                "0px 30px",
                "0px 30px",
                0
            ],
            textAlign: [
                "center",
                "center",
                "center",
                "left"
            ]
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DuetoneCheckmark, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 12
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h5", {
                        css: {
                            margin: 0,
                            color: palette/* blueBayoux */.xS,
                            fontWeight: "bold",
                            fontSize: 14,
                            lineHeight: 1.33,
                            letterSpacing: 1,
                            textTransform: "uppercase"
                        },
                        children: feature
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* blueBayoux */.xS,
                            fontWeight: 300,
                            fontSize: 14,
                            lineHeight: 1.33,
                            letterSpacing: 1
                        },
                        children: description
                    })
                ]
            })
        ]
    });
}
function KeyFeatures() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        css: {
            display: "grid",
            gridRowGap: 36,
            gridTemplateColumns: "1fr",
            maxWidth: 1140,
            margin: "0px auto"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                    css: (0,mediaQueries/* default */.Z)({
                        margin: 0,
                        color: palette/* blueBayoux */.xS,
                        fontWeight: "bold",
                        fontSize: [
                            18,
                            21,
                            21,
                            21
                        ],
                        lineHeight: 1.33,
                        letterSpacing: 1,
                        textAlign: [
                            "center",
                            "center",
                            "center",
                            "left"
                        ],
                        textTransform: "uppercase"
                    }),
                    children: "Quais s\xe3o as vantagens?"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    display: "grid",
                    gridRowGap: 30,
                    gridColumnGap: 30,
                    gridTemplateColumns: [
                        "repeat(2, 1fr)",
                        "repeat(12, 1fr)",
                        "repeat(12, 1fr)",
                        "repeat(12, 1fr)"
                    ],
                    justifyContent: "center"
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            gridColumn: "span 6",
                            display: "grid",
                            gridRowGap: 16
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                            css: {
                                margin: 0,
                                padding: 0,
                                listStyle: "none",
                                display: "grid",
                                gridRowGap: 36
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFeature, {
                                        feature: "An\xe1lise Fundamentalista",
                                        description: "Analise de forma r\xe1pida e objetiva os balan\xe7os de milhares de empresas e fundos imobili\xe1rios."
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFeature, {
                                        feature: "An\xe1lise Gr\xe1fica",
                                        description: "Veja como as empresas desempenharam historicamente olhando as cota\xe7\xf5es mais antigas."
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFeature, {
                                        feature: "An\xe1lise em V\xeddeo",
                                        description: "V\xeddeo exclusivo com a an\xe1lise fundamentalista de diversas a\xe7\xf5es e fundos imobili\xe1rios."
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            gridColumn: "span 6",
                            display: "grid",
                            gridRowGap: 16
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                            css: {
                                margin: 0,
                                padding: 0,
                                listStyle: "none",
                                display: "grid",
                                gridRowGap: 36
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFeature, {
                                        feature: "Ranking de A\xe7\xf5es, Stocks e FIIs",
                                        description: "Veja quais s\xe3o os melhores ativos de acordo com a avalia\xe7\xe3o dos usu\xe1rios do site."
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFeature, {
                                        feature: "Dados das Empresas",
                                        description: "Veja de forma simplificada o C\xf3digo de Negocia\xe7\xe3o, Atividade, Segmento de Listagem, Tag Along e Posi\xe7\xe3o Acion\xe1ria."
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFeature, {
                                        feature: "Dados dos Fundos Imobili\xe1rios",
                                        description: "Veja de forma simplificada o tipo do fundo, a distribui\xe7\xe3o dos ativos, as taxas, os ativos e localiza\xe7\xe3o dos im\xf3veis."
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function DuetoneCheckmark(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 37,
        height: 28
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "#2F4EDA",
                    d: "M36.46 5.864L19.166 23.443l-5.247-5.317L31.238.553a1.828 1.828 0 012.601-.01l.01.01 2.61 2.655a1.9 1.9 0 010 2.656z",
                    opacity: 0.4
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "#627BEA",
                    d: "M19.161 23.45l-3.935 4a1.825 1.825 0 01-2.601.01l-.01-.01L.613 15.247a1.899 1.899 0 010-2.655l2.611-2.655a1.824 1.824 0 012.596-.012l.012.012 13.33 13.512z"
                })
            ]
        })
    }));
}
function WhoAreWe() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        css: (0,mediaQueries/* default */.Z)({
            display: "grid",
            gridColumnGap: 30,
            gridRowGap: 30,
            gridTemplateColumns: [
                "1fr",
                "1fr",
                "1fr",
                "repeat(12, 1fr)"
            ],
            justifyContent: "center",
            maxWidth: 1140,
            margin: "0px auto",
            padding: "36px 30px",
            textAlign: [
                "center",
                "left",
                "left",
                "left"
            ]
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    gridColumn: "span 6"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 16
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                            css: (0,mediaQueries/* default */.Z)({
                                margin: 0,
                                color: palette/* blueBayoux */.xS,
                                fontWeight: "bold",
                                fontSize: 18,
                                lineHeight: 1.33,
                                letterSpacing: 1,
                                textTransform: "uppercase"
                            }),
                            children: "Sobre n\xf3s"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: (0,mediaQueries/* default */.Z)({
                                margin: 0,
                                color: palette/* blueBayoux */.xS,
                                fontWeight: 300,
                                fontSize: [
                                    14,
                                    16
                                ],
                                lineHeight: 1.66,
                                letterSpacing: 1
                            }),
                            children: "Acreditamos que o Buy&Hold seja o m\xe9todo de investimento que mais se sustenta no longo prazo na Bolsa de Valores. O Fundamentei \xe9 a uni\xe3o dos nossos esfor\xe7os para que voc\xea tenha em um \xfanico site o acesso a todas as informa\xe7\xf5es que consideramos essenciais para voc\xea escolher os melhores ativos com foco no longo prazo."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 28,
                    gridColumn: "span 6"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: (0,mediaQueries/* default */.Z)({
                            display: "grid",
                            gridTemplateColumns: [
                                "1fr",
                                "max-content 1fr",
                                "max-content 1fr",
                                "max-content 1fr"
                            ],
                            gridColumnGap: 20,
                            gridRowGap: 20
                        }),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "flex justify-center",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "".concat((0,getBaseUrl/* default */.Z)(), "/static/people/eduardo.jpg"),
                                    alt: "Eduardo Cavalcanti",
                                    className: "h-16 w-16 rounded-3xl object-cover",
                                    width: 64,
                                    height: 64
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridRowGap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                                        css: {
                                            margin: 0,
                                            color: palette/* blueBayoux */.xS,
                                            fontWeight: "bold",
                                            fontSize: 16,
                                            lineHeight: 1.33,
                                            letterSpacing: 1.4
                                        },
                                        children: "Eduardo Cavalcanti"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            margin: 0,
                                            color: palette/* blueBayoux */.xS,
                                            fontSize: 14,
                                            fontStyle: "italic",
                                            lineHeight: 1.66,
                                            letterSpacing: 1
                                        },
                                        children: "P\xf3s-graduado em Finan\xe7as, Investimentos e Banking pela PUCRS, \xe9 especialista em Mercado de Capitais (ANBIMA), Consultor de Valores Mobili\xe1rios (CVM) e Analista de Valores Mobili\xe1rios (APIMEC). Criador do m\xe9todo Investidor \xc1guia, exclusivo para investidores adeptos \xe0 filosofia Buy&Hold."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: (0,mediaQueries/* default */.Z)({
                            display: "grid",
                            gridTemplateColumns: [
                                "1fr",
                                "max-content 1fr",
                                "max-content 1fr",
                                "max-content 1fr"
                            ],
                            gridColumnGap: 20,
                            gridRowGap: 20
                        }),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "flex justify-center",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "".concat((0,getBaseUrl/* default */.Z)(), "/static/people/andrey.jpg"),
                                    alt: "Andrey Vital",
                                    className: "h-16 w-16 rounded-3xl object-cover",
                                    width: 64,
                                    height: 64
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridRowGap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                                        css: {
                                            margin: 0,
                                            color: palette/* blueBayoux */.xS,
                                            fontWeight: "bold",
                                            fontSize: 16,
                                            lineHeight: 1.33,
                                            letterSpacing: 1.4
                                        },
                                        children: "Andrey Vital"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            margin: 0,
                                            color: palette/* blueBayoux */.xS,
                                            fontSize: 14,
                                            fontStyle: "italic",
                                            lineHeight: 1.66,
                                            letterSpacing: 1
                                        },
                                        children: "Desenvolvedor de Software h\xe1 mais de 9 anos. Trabalhou em empresas como Toptal, ClassDojo, DigitalRelab, VNA Group e atualmente est\xe1 focado em criar o melhor site de an\xe1lise fundamentalista do mundo."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/layouts/NavbarLayout.tsx + 30 modules
var NavbarLayout = __webpack_require__(67253);
// EXTERNAL MODULE: ./components/qol/BackToTop.tsx
var BackToTop = __webpack_require__(64376);
// EXTERNAL MODULE: ./components/screener/Divider.tsx
var Divider = __webpack_require__(6330);
// EXTERNAL MODULE: ./components/conversion/FeatureBox.tsx
var FeatureBox = __webpack_require__(62045);
// EXTERNAL MODULE: ./lib/hooks/useSelfie.ts
var useSelfie = __webpack_require__(2254);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectMenu.js
var connectMenu = __webpack_require__(94049);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/lib/tw-merge.mjs + 11 modules
var tw_merge = __webpack_require__(66180);
;// CONCATENATED MODULE: ./components/screener/refinements/AssetType.tsx










function AssetType() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AssetTypeMenu, {
        attribute: "type"
    });
};
var AssetTypeMenu = (0,connectMenu/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine, currentRefinement = param.currentRefinement;
    var viewer = (0,useSelfie/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: (0,clsx_m/* default */.Z)("space-y-1 font-aeonik", {
                    hidden: currentRefinement === null
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Filtrar Por"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                        children: "Escolha um tipo de ativo."
                    })
                ]
            }),
            currentRefinement !== null ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(miolo/* NativeSelect */.px, {
                value: currentRefinement || "",
                onChange: function(event) {
                    return refine(event.currentTarget.value || "");
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "",
                        children: "Todos"
                    }),
                    items.filter(function(item) {
                        return getHumanReadableLabel(item.label);
                    }).sort(function(a, b) {
                        return SORT_BY.indexOf(getHumanReadableLabel(a.label) || "") - SORT_BY.indexOf(getHumanReadableLabel(b.label) || "");
                    }).map(function(item) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                            value: item.label,
                            children: getHumanReadableLabel(item.label)
                        }, item.label);
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "grid grid-cols-2 gap-6 lg:flex lg:grid-cols-2 lg:flex-col",
                children: items.filter(function(item) {
                    return getHumanReadableLabel(item.label);
                }).sort(function(a, b) {
                    return SORT_BY.indexOf(getHumanReadableLabel(a.label) || "") - SORT_BY.indexOf(getHumanReadableLabel(b.label) || "");
                }).map(function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: (0,tw_merge/* twMerge */.m)("group relative", "before:absolute before:-inset-1.5 before:rounded-[20px]", "before:bg-violet-100 before:opacity-0 hover:before:opacity-100"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            "aria-label": "Filtrar por ".concat(getHumanReadableLabel(item.label)),
                            onClick: function() {
                                return refine(item.value || "");
                            },
                            className: (0,tw_merge/* twMerge */.m)("group", "relative cursor-pointer rounded-xl bg-slate-100 p-4 text-left font-aeonik", "border border-transparent", "w-full ring-1 ring-slate-500/20 hover:ring-violet-300"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: (0,tw_merge/* twMerge */.m)("flex flex-col-reverse items-center justify-center text-center", "md:flex-row md:justify-between"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        className: "mt-2 space-y-1 md:mt-0",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h5", {
                                                className: "flex justify-center text-sm font-bold text-slate-500 group-hover:text-violet-600 md:justify-start",
                                                children: getHumanReadableLabel(item.label)
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                className: "flex justify-center text-sm font-medium text-slate-400 md:justify-start",
                                                children: [
                                                    item.count,
                                                    " ativos"
                                                ]
                                            })
                                        ]
                                    }),
                                    (item.value === "BRAZILIAN_COMPANY" || item.value === "BRAZILIAN_REAL_ESTATE_FUND") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChristTheRedeemer, {
                                        className: "opacity-50 group-hover:opacity-100"
                                    }),
                                    (item.value === "AMERICAN_COMPANY" || item.value === "AMERICAN_REIT") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatueOfLiberty, {
                                        className: "opacity-50 group-hover:opacity-100"
                                    })
                                ]
                            })
                        })
                    }, item.label);
                })
            }),
            viewer && !viewer.isPremium && currentRefinement === null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.Z, {
                displayOrigin: "Screener",
                callToActionText: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        "Turbine suas an\xe1lises com ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                            children: "dados exclusivos"
                        }),
                        " de mais de 6.000 ativos."
                    ]
                }),
                featureHighlights: [
                    "Acesso ao Ranking completo",
                    "Agenda de Dividendos",
                    "Central de Resultados",
                    "Hist\xf3rico m\xe1ximo de dados", 
                ]
            })
        ]
    });
});
var SORT_BY = [
    "A\xe7\xf5es",
    "FIIs",
    "Stocks",
    "REITs"
];
function getHumanReadableLabel(machineReadableLabel) {
    if (machineReadableLabel === "AMERICAN_COMPANY") {
        return "Stocks";
    }
    if (machineReadableLabel === "AMERICAN_REIT") {
        return "REITs";
    }
    if (machineReadableLabel === "BRAZILIAN_COMPANY") {
        return "A\xe7\xf5es";
    }
    if (machineReadableLabel === "BRAZILIAN_REAL_ESTATE_FUND") {
        return "FIIs";
    }
    return null;
}
function ChristTheRedeemer(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 25,
        height: 35,
        viewBox: "0 0 25 35"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fillRule: "nonzero",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M20.109 32.813H4.89v-17.5c0-2.417 1.947-4.376 4.348-4.376h6.522c2.401 0 4.348 1.96 4.348 4.376v17.5z",
                    fill: "#C8F5F0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "#A494A4",
                    d: "M8.152 27.89h8.696v4.376H8.152z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M14.13 4.922V2.188c0-.907-.73-1.641-1.63-1.641-.9 0-1.63.734-1.63 1.64v2.735L3.456 6.414c-.491.099-.195.149-.195.149L4.43 8.505c.295.49.824.79 1.395.79h3.958v18.595h5.434V9.297h3.958c.57 0 1.1-.3 1.395-.791l1.17-1.944-.196-.148-7.414-1.492z",
                    fill: "#FFEACD"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "#FFD3AE",
                    d: "M15.217 21.328l-5.434-3.281v9.844h5.434z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M5.978 33.36c0 .905.73 1.64 1.63 1.64h9.783c.9 0 1.63-.735 1.63-1.64H5.979z",
                    fill: "#D1C9D1"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M19.022 33.906H5.978c-.6 0-1.087-.49-1.087-1.093l.544-.547h14.13l.544.547a1.09 1.09 0 01-1.087 1.093z",
                    fill: "#A494A4"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M15.543 17.61l-1.521-1.15a1.101 1.101 0 01-.435-.874v-9.57c0-.302.244-.547.543-.547.3 0 .544-.245.544-.547a.545.545 0 00-.544-.547c-.899 0-1.63.736-1.63 1.64v1.456L9.235 4.944a.541.541 0 00-.762.1.55.55 0 00.1.767l3.927 3.04v1.523L6.31 5.582a.541.541 0 00-.763.1.55.55 0 00.1.767l6.853 5.305v3.832c0 .685.325 1.339.87 1.75l1.521 1.148a.538.538 0 00.761-.109.55.55 0 00-.109-.766z",
                    fill: "#7C657C"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M24.457 6.016h-1.421a7.04 7.04 0 01-1.386-.138l-6.976-1.404V2.187A2.183 2.183 0 0012.5 0a2.183 2.183 0 00-2.174 2.188v2.286L3.35 5.878a7.04 7.04 0 01-1.386.138H.544c-.3 0-.544.244-.544.546 0 .303.243.547.543.547h1.421c.319 0 .639-.02.956-.057L3.965 8.79a2.183 2.183 0 001.86 1.055h3.414V27.89c0 .302.243.547.544.547.3 0 .543-.245.543-.547v-8.878l4.348 2.625v6.253c0 .302.243.547.543.547.3 0 .544-.245.544-.547V9.844h3.414c.756 0 1.469-.404 1.86-1.055l1.045-1.737c.317.038.637.057.956.057h1.42c.3 0 .544-.244.544-.546a.545.545 0 00-.543-.547zm-4.352 2.207a1.092 1.092 0 01-.93.527h-3.958c-.3 0-.543.245-.543.547v11.065l-4.348-2.625v-8.44a.545.545 0 00-.543-.547H5.825c-.378 0-.735-.202-.93-.527l-.827-1.375 6.908-1.39a.546.546 0 00.437-.536V2.188c0-.604.488-1.094 1.087-1.094.6 0 1.087.49 1.087 1.093v2.735c0 .26.183.485.437.536l6.908 1.39-.827 1.375z",
                    fill: "#503250"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M16.848 27.344h-3.805v-6.69l-1.086-.657v7.347H8.152c-.3 0-.543.245-.543.547v4.375c0 .302.243.547.543.547.3 0 .544-.245.544-.547v-3.828h7.608v3.828c0 .302.244.547.544.547.3 0 .543-.245.543-.547V27.89a.545.545 0 00-.543-.547z",
                    fill: "#7C657C"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M20.109 32.833H4.9a1.09 1.09 0 011.087-1.094h13.035c.6 0 1.087.49 1.087 1.094z",
                    fill: "#503250"
                })
            ]
        })
    }));
}
function StatueOfLiberty(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 23,
        height: 35,
        viewBox: "0 0 23 35"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fillRule: "nonzero",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    fill: "#368A50",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M14.342 14.917a.53.53 0 01-.524-.536V9.774a.53.53 0 01.524-.536c.29 0 .524.24.524.536v4.607a.53.53 0 01-.524.536zM16.234 15.454a.513.513 0 01-.27-.077.543.543 0 01-.178-.735l1.956-3.324a.517.517 0 01.719-.183.543.543 0 01.179.736l-1.956 3.324a.522.522 0 01-.45.26zM17.342 16.506a.52.52 0 01-.429-.227.543.543 0 01.127-.746l2.567-1.853a.517.517 0 01.73.13.543.543 0 01-.125.746l-2.568 1.852a.513.513 0 01-.302.098zM17.862 17.604a.538.538 0 01-.149-1.05l2.078-.629a.522.522 0 01.65.362.538.538 0 01-.353.666l-2.077.629a.509.509 0 01-.15.022zM12.45 15.454a.521.521 0 01-.449-.26l-1.956-3.323a.543.543 0 01.179-.736.518.518 0 01.719.183l1.956 3.324c.15.254.07.583-.179.735a.513.513 0 01-.27.077zM11.343 16.506a.514.514 0 01-.302-.098l-2.568-1.852a.543.543 0 01-.126-.747.517.517 0 01.73-.129l2.568 1.853c.237.17.293.505.126.746a.52.52 0 01-.428.227zM10.823 17.604c-.05 0-.1-.007-.149-.022l-2.077-.63a.538.538 0 01-.354-.665.522.522 0 01.651-.361l2.078.629a.538.538 0 01-.149 1.05zM10.675 29.09V18.132h7.335v13.96"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "#5EBC77",
                    d: "M20.889 31.026l1.208-1.128-3.354-4.714h-6.811l-3.248-1.482-3.616-12.606H3.444l1.991 16.767-1.572 2.013 2.41 3.022V35h16.662z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    fill: "#368A50",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M7.157 25.658L3.624 12.607l1.811 15.256"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M8.684 23.702l-3.146 8.274-1.675-2.1zM8.247 22.177l.437 1.525-3.249 4.16-.422-3.557zM5.069 6.292v4.804h-1.82c-.141 0-.278-.018-.41-.052a1.723 1.723 0 01-1.281-1.678V6.292h3.51zM10.113 35l5.45-9.816h3.18L11.685 35z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M5.069 8.94v2.156h-1.82c-.141 0-.278-.018-.41-.052V9.948a.998.998 0 01.987-1.009h1.243z",
                    fill: "#5EBC77"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "#FFA700",
                    d: "M1.422 5.471l-.6-4.433L2.417 2.31 3.59 0l.758 2.17 1.456-1.132-.507 4.433"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M14.342 14.381c-2.025 0-3.667 1.68-3.667 3.75v1.821c0 2.071 1.642 3.75 3.667 3.75 2.026 0 3.668-1.679 3.668-3.75v-1.821c0-2.07-1.642-3.75-3.668-3.75z",
                    fill: "#5EBC77"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    fill: "#368A50",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M11.932 19.952v-1.821c0-1.852 1.313-3.389 3.04-3.694a3.605 3.605 0 00-.63-.056c-2.025 0-3.667 1.679-3.667 3.75v1.821c0 2.071 1.642 3.75 3.667 3.75.215 0 .425-.02.63-.056-1.727-.305-3.04-1.842-3.04-3.694z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M18.01 18.131v1.821l-.02.002a3.77 3.77 0 00-1.054-2.26 3.617 3.617 0 00-2.594-1.098c-1.96 0-3.562 1.573-3.662 3.552a3.684 3.684 0 01-.005-.196v-1.82c0-1.036.411-1.974 1.074-2.653a3.617 3.617 0 012.593-1.098c2.026 0 3.668 1.679 3.668 3.75z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "#47A562",
                    d: "M.065 5.435h6.497v1.714H.065z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    fill: "#368A50",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M.065 5.435h2.783V7.15H.065zM16.455 18.998l-1.993-.478h-.005a.504.504 0 00-.043-.008l-.014-.003a.516.516 0 00-.115 0c-.005 0-.01.002-.014.003a.532.532 0 00-.043.007l-.005.001-1.994.478a.536.536 0 00-.39.643.524.524 0 00.63.4l1.35-.323v.801a.53.53 0 00.524.536.53.53 0 00.523-.536v-.801l1.35.323a.527.527 0 00.63-.4.537.537 0 00-.39-.643zM20.889 31.026l-2.892 2.708 3.379-1.762M11.932 25.184l-2.039 2.978.782-3.551"
                    })
                })
            ]
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectCurrentRefinements.js
var connectCurrentRefinements = __webpack_require__(87955);
;// CONCATENATED MODULE: ./components/screener/refinements/ClearAllFilters.tsx




var ClearAllFilters = (0,connectCurrentRefinements/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "w-full text-right",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
            type: "button",
            className: (0,tw_merge/* twMerge */.m)("bg-red-50 font-aeonik text-xs font-medium uppercase tracking-wider text-red-700", "hover:bg-red-500 hover:text-white", "w-full rounded-xl border border-red-900/20 p-4", "lg:w-auto lg:rounded-full lg:border-transparent lg:px-3 lg:py-1"),
            disabled: items.length === 0,
            onClick: function() {
                if (router.query.searchState) {
                    router.replace("/", "/");
                }
                refine(items);
            },
            children: "Remover filtros"
        })
    });
});
/* harmony default export */ var refinements_ClearAllFilters = (ClearAllFilters);

// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectRange.js
var connectRange = __webpack_require__(31675);
;// CONCATENATED MODULE: ./components/screener/shared/ConnectedSliderRange.tsx






function ConnectedSliderRange(param) {
    var label = param.label, accessibilityLabels = param.accessibilityLabels, refine = param.refine, currentRefinement = param.currentRefinement;
    var ref = (0,react.useState)(null), willUpdateToValues = ref[0], setWillUpdateToValues = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 20
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    justifyContent: "space-between",
                    color: palette/* mariner */.Mw,
                    fontWeight: "bold",
                    fontSize: 14,
                    letterSpacing: 1
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontWeight: 700
                        },
                        children: label
                    }),
                    willUpdateToValues ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                        css: {
                            fontWeight: 700,
                            color: palette/* baliHai */.r
                        },
                        children: [
                            willUpdateToValues[0] || 0,
                            "% \u2014 ",
                            willUpdateToValues[1] || 100,
                            "%"
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                        css: {
                            fontWeight: 700
                        },
                        children: [
                            currentRefinement.min || 0,
                            "% \u2014 ",
                            currentRefinement.max || 100,
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* RangeSlider */.U2, {
                domain: [
                    0,
                    100
                ],
                values: [
                    currentRefinement.min || 0,
                    currentRefinement.max || 100
                ],
                labels: accessibilityLabels,
                onUpdate: setWillUpdateToValues,
                onChange: function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), min = _param[0], max = _param[1];
                    setWillUpdateToValues(null);
                    if (min === 0 && max === 100) {
                        refine({
                            min: undefined,
                            max: undefined
                        });
                    } else {
                        refine({
                            min: min,
                            max: max
                        });
                    }
                }
            })
        ]
    });
}
/* harmony default export */ var shared_ConnectedSliderRange = ((0,connectRange/* default */.Z)(ConnectedSliderRange));

;// CONCATENATED MODULE: ./components/screener/refinements/FreeFloat.tsx


function FreeFloat() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Free Float"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                        children: "Selecione uma faixa de Free Float."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedSliderRange, {
                        attribute: "freeFloat.commonStock",
                        label: "A\xe7\xf5es ON",
                        accessibilityLabels: [
                            "Free Float m\xednimo das A\xe7\xf5es Ordin\xe1rias",
                            "Free Float m\xe1ximo das A\xe7\xf5es Ordin\xe1rias"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedSliderRange, {
                        attribute: "freeFloat.preferredStock",
                        label: "A\xe7\xf5es PN",
                        accessibilityLabels: [
                            "Free Float m\xednimo das A\xe7\xf5es Preferenciais",
                            "Free Float m\xe1ximo das A\xe7\xf5es Preferenciais", 
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/GovernmentOwnership.tsx



var GovernmentOwnershipMenu = (0,connectMenu/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine, currentRefinement = param.currentRefinement;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4 font-aeonik font-normal",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "text-base font-bold uppercase tracking-wide text-zinc-500",
                children: "Governo como S\xf3cio"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(miolo/* NativeSelect */.px, {
                value: currentRefinement || "",
                onChange: function(event) {
                    return refine(event.currentTarget.value || "");
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "",
                        children: currentRefinement === null ? "Selecionar filtro" : "Limpar filtro"
                    }),
                    items.map(function(item) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                            value: item.label,
                            children: item.label === "true" ? "Qualquer participa\xe7\xe3o" : "Sem participa\xe7\xe3o"
                        }, item.label);
                    })
                ]
            })
        ]
    });
});
function GovernmentOwnership() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentOwnershipMenu, {
        attribute: "isGovernmentAShareholder"
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/ToggableRefinementList.tsx



function ToggableRefinementList(param) {
    var items = param.items, refine = param.refine;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        className: "space-y-4",
        children: items.map(function(param) {
            var isRefined = param.isRefined, value = param.value, label = param.label, count = param.count;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                    type: "button",
                    onClick: function() {
                        return refine(value);
                    },
                    className: (0,tw_merge/* twMerge */.m)("group", "m-0 cursor-pointer p-0 text-sm font-normal tracking-wide text-slate-500", "flex w-full items-center justify-between", (0,clsx_m/* default */.Z)({
                        "font-bold text-violet-600": isRefined
                    })),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "mr-6 overflow-hidden text-ellipsis whitespace-nowrap",
                            children: label.trim()
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: (0,tw_merge/* twMerge */.m)("group relative", "before:absolute before:-inset-1.5 before:rounded-md before:bg-violet-50 before:opacity-0", "text-slate-500", (0,clsx_m/* default */.Z)({
                                "text-violet-600 before:opacity-100": isRefined
                            })),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                className: "relative select-none text-sm font-bold",
                                children: count
                            })
                        })
                    ]
                })
            }, label);
        })
    });
};

;// CONCATENATED MODULE: ./lib/hooks/useInfinitePagination.ts

function useInfinitePagination(props) {
    var ref = (0,react.useState)(1), offset = ref[0], setOffset = ref[1];
    var hasMoreToShow = offset * props.itemsPerPage < props.items.length;
    return {
        items: props.items.slice(0, offset * props.itemsPerPage),
        itemsPerPage: props.itemsPerPage,
        hasMoreToShow: hasMoreToShow,
        showMore: function() {
            if (hasMoreToShow) {
                setOffset(offset + 1);
            }
        },
        reset: function() {
            return setOffset(1);
        }
    };
};

// EXTERNAL MODULE: ./node_modules/lodash/fp/deburr.js
var deburr = __webpack_require__(796);
var deburr_default = /*#__PURE__*/__webpack_require__.n(deburr);
// EXTERNAL MODULE: ./node_modules/lodash/fp/orderBy.js
var orderBy = __webpack_require__(60918);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectRefinementList.js
var connectRefinementList = __webpack_require__(75805);
;// CONCATENATED MODULE: ./components/screener/refinements/IndustrySector.tsx









var IndustrySectorRefinementList = (0,connectRefinementList/* default */.Z)(function(param) {
    var isChoosingSectors = param.isChoosingSectors, onToggleChooseSectors = param.onToggleChooseSectors, items = param.items, refine = param.refine;
    var industrySectors = orderBy_default()([
        "isRefined",
        "count",
        "label"
    ], [
        "desc",
        "desc",
        "asc"
    ], items);
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var pagination = useInfinitePagination({
        itemsPerPage: 10,
        items: industrySectors.filter(function(item) {
            if (searchQuery && searchQuery.trim()) {
                var cleanSearchQuery = searchQuery.trim();
                return deburr_default()(item.label).toLowerCase().includes(deburr_default()(cleanSearchQuery).toLowerCase());
            }
            return true;
        })
    });
    (0,react.useEffect)(function() {
        if (searchQuery !== "") {
            pagination.reset();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    var refinements = items.filter(function(item) {
        return item.isRefined;
    });
    if (!isChoosingSectors) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "space-y-1",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                            className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                            children: "Setor"
                        }),
                        refinements.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex items-center space-x-1",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "font-aeonik text-sm font-medium italic tracking-wide text-slate-400",
                                    children: "Filtrando por"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                    className: "rounded-xl border border-violet-300 bg-violet-50 px-2 py-0.5 text-xs font-bold text-violet-700",
                                    children: [
                                        refinements.length,
                                        " ",
                                        refinements.length === 1 ? "setor" : "setores"
                                    ]
                                })
                            ]
                        }),
                        refinements.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                                children: "Filtre empresas por setor."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "button",
                    className: "font-aeonik text-sm font-medium tracking-wide text-blue-600 hover:underline disabled:text-slate-400",
                    onClick: function() {
                        return onToggleChooseSectors(true);
                    },
                    disabled: items.length === 0,
                    children: refinements.length > 0 ? "Escolher outros setores (".concat(items.length, ")") : "Escolher setores (".concat(items.length, ")")
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Setor"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal tracking-wide text-slate-400",
                        children: "Escolha um ou v\xe1rios setores."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* MiniSearchInput */.D$, {
                value: searchQuery,
                placeholder: "Pesquisar",
                onChange: function(searchQuery) {
                    return setSearchQuery(searchQuery);
                }
            }),
            pagination.items.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggableRefinementList, {
                        items: pagination.items,
                        refine: refine
                    }),
                    pagination.hasMoreToShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            onClick: pagination.showMore,
                            className: "font-aeonik text-sm font-medium tracking-wide text-sky-600 hover:underline",
                            children: "Ver mais setores"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        variant: "faded"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            className: "font-aeonik text-sm font-medium tracking-wide text-violet-600 hover:underline",
                            onClick: function() {
                                onToggleChooseSectors(false);
                                pagination.reset();
                            },
                            children: "Ver todos os filtros"
                        })
                    })
                ]
            })
        ]
    });
});
function IndustrySector(param) {
    var isChoosingSectors = param.isChoosingSectors, onToggleChooseSectors = param.onToggleChooseSectors;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndustrySectorRefinementList, {
        isChoosingSectors: isChoosingSectors,
        onToggleChooseSectors: onToggleChooseSectors,
        attribute: "industrySector",
        limit: 180
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/ListingSegment.tsx






var ListingSegmentRefinementList = (0,connectRefinementList/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine;
    var listingSegments = orderBy_default()([
        "count"
    ], [
        "desc"
    ], items);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                children: "Segmento de Listagem"
            }),
            listingSegments.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                className: "font-aeonik text-sm font-normal tracking-wide text-slate-500",
                children: "Nenhum segmento encontrado :("
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggableRefinementList, {
                refine: refine,
                items: listingSegments.map(function(item) {
                    if (item.label === "N\xedvel 1 de Governan\xe7a Corporativa") {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            label: "N\xedvel 1"
                        });
                    }
                    if (item.label === "N\xedvel 2 de Governan\xe7a Corporativa") {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            label: "N\xedvel 2"
                        });
                    }
                    return item;
                })
            })
        ]
    });
});
function ListingSegment() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListingSegmentRefinementList, {
        attribute: "listingSegment"
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/NetMargin.tsx


function NetMargin() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Margem"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                        children: "Filtre por margem de lucro."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedSliderRange, {
                attribute: "lastYearlyFinancials.netMargin",
                label: "Margem l\xedquida",
                accessibilityLabels: [
                    "Margem de lucro m\xednima",
                    "Margem de lucro m\xe1xima"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/RealEstateFundAdministrator.tsx








var RealEstateFundAdministratorRefinementList = (0,connectRefinementList/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine;
    var administrators = orderBy_default()([
        "isRefined",
        "count",
        "label"
    ], [
        "desc",
        "desc",
        "asc"
    ], items);
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var pagination = useInfinitePagination({
        itemsPerPage: 5,
        items: administrators.filter(function(item) {
            if (searchQuery && searchQuery.trim()) {
                var cleanSearchQuery = searchQuery.trim();
                return deburr_default()(item.label).toLowerCase().includes(deburr_default()(cleanSearchQuery).toLowerCase());
            }
            return true;
        })
    });
    (0,react.useEffect)(function() {
        if (searchQuery !== "") {
            pagination.reset();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4 font-aeonik",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Administrator"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wide text-slate-400",
                        children: "Filtre por administradores."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* MiniSearchInput */.D$, {
                value: searchQuery,
                placeholder: "Pesquisar",
                onChange: function(searchQuery) {
                    return setSearchQuery(searchQuery);
                }
            }),
            pagination.items.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggableRefinementList, {
                        items: pagination.items,
                        refine: refine
                    }),
                    pagination.hasMoreToShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            onClick: pagination.showMore,
                            className: "font-aeonik text-sm font-medium tracking-wide text-sky-600 hover:underline",
                            children: "Ver mais administradores"
                        })
                    })
                ]
            })
        ]
    });
});
function RealEstateFundAdministrator() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundAdministratorRefinementList, {
        attribute: "administrator",
        limit: 120
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/RealEstateFundAudience.tsx



var RealEstateFundAudienceMenu = (0,connectMenu/* default */.Z)(function(param) {
    var refine = param.refine, currentRefinement = param.currentRefinement;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                children: "Publico-alvo"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(miolo/* NativeSelect */.px, {
                value: currentRefinement || "",
                onChange: function(event) {
                    return refine(event.currentTarget.value || "");
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "",
                        children: "Todos"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Investidor Profissional",
                        children: "Investidor Profissional"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Investidor Qualificado",
                        children: "Investidor Qualificado"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Investidor Qualificado e Profissional",
                        children: "Investidor Qualificado e Profissional"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Investidores em Geral",
                        children: "Investidores em Geral"
                    })
                ]
            })
        ]
    });
});
function RealEstateFundAudience() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundAudienceMenu, {
        attribute: "audience"
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/RealEstateFundClassification.tsx




var RealEstateFundClassificationRefinementList = (0,connectRefinementList/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine;
    var classifications = orderBy_default()([
        "count"
    ], [
        "desc"
    ], items);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4 font-aeonik",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Tipo"
                    }),
                    classifications.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        className: "font-aeonik text-sm font-normal tracking-wide text-slate-500",
                        children: "Nenhum tipo encontrado :("
                    })
                ]
            }),
            classifications.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggableRefinementList, {
                items: classifications,
                refine: refine
            })
        ]
    });
});
function RealEstateFundClassification() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundClassificationRefinementList, {
        attribute: "classification"
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/RealEstateFundManagement.tsx



var RealEstateFundManagementMenu = (0,connectMenu/* default */.Z)(function(param) {
    var refine = param.refine, currentRefinement = param.currentRefinement;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                children: "Gest\xe3o"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(miolo/* NativeSelect */.px, {
                value: currentRefinement || "",
                onChange: function(event) {
                    return refine(event.currentTarget.value || "");
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "",
                        children: "Todos"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Ativa",
                        children: "Ativa"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Passiva",
                        children: "Passiva"
                    })
                ]
            })
        ]
    });
});
function RealEstateFundManagement() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundManagementMenu, {
        attribute: "management"
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/RealEstateFundManager.tsx








var RealEstateFundManagerRefinementList = (0,connectRefinementList/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine;
    var managers = orderBy_default()([
        "isRefined",
        "count",
        "label"
    ], [
        "desc",
        "desc",
        "asc"
    ], items);
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var pagination = useInfinitePagination({
        itemsPerPage: 5,
        items: managers.filter(function(item) {
            if (searchQuery && searchQuery.trim()) {
                var cleanSearchQuery = searchQuery.trim();
                return deburr_default()(item.label).toLowerCase().includes(deburr_default()(cleanSearchQuery).toLowerCase());
            }
            return true;
        })
    });
    (0,react.useEffect)(function() {
        if (searchQuery !== "") {
            pagination.reset();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Gestor"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wide text-slate-400",
                        children: "Filtre por Gestores"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* MiniSearchInput */.D$, {
                value: searchQuery,
                placeholder: "Pesquisar",
                onChange: function(searchQuery) {
                    return setSearchQuery(searchQuery);
                }
            }),
            pagination.items.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggableRefinementList, {
                        items: pagination.items,
                        refine: refine
                    }),
                    pagination.hasMoreToShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            onClick: pagination.showMore,
                            className: "font-aeonik text-sm font-medium tracking-wide text-sky-600 hover:underline",
                            children: "Ver mais gestores"
                        })
                    })
                ]
            })
        ]
    });
});
function RealEstateFundManager() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundManagerRefinementList, {
        attribute: "manager",
        limit: 120
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/RealEstateFundMandate.tsx



var RealEstateFundMandateMenu = (0,connectMenu/* default */.Z)(function(param) {
    var refine = param.refine, currentRefinement = param.currentRefinement;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                children: "Mandato"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(miolo/* NativeSelect */.px, {
                value: currentRefinement || "",
                onChange: function(event) {
                    return refine(event.currentTarget.value || "");
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "",
                        children: "Todos"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "H\xedbrido",
                        children: "H\xedbrido"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Renda",
                        children: "Renda"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Desenvolvimento para Renda",
                        children: "Desenvolvimento para Renda"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "Desenvolvimento para Venda",
                        children: "Desenvolvimento para Venda"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "T\xedtulos e Valores Mobili\xe1rios",
                        children: "T\xedtulos e Valores Mobili\xe1rios"
                    })
                ]
            })
        ]
    });
});
function RealEstateFundMandate() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundMandateMenu, {
        attribute: "mandate"
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/RealEstateFundOperatingSegment.tsx



var RealEstateFundOperatingSegmentMenu = (0,connectMenu/* default */.Z)(function(param) {
    var items = param.items, refine = param.refine, currentRefinement = param.currentRefinement;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                children: "Segmento"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(miolo/* NativeSelect */.px, {
                value: currentRefinement || "",
                onChange: function(event) {
                    return refine(event.currentTarget.value || "");
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: "",
                        children: "Todos"
                    }),
                    items.map(function(item) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                            value: item.label,
                            children: item.label
                        }, item.label);
                    })
                ]
            })
        ]
    });
});
function RealEstateFundOperatingSegment() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundOperatingSegmentMenu, {
        attribute: "industrySegment"
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/TagAlong.tsx


function TagAlong() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Tag Along"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                        children: "Selecione uma faixa de Tag Along."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-9",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedSliderRange, {
                        attribute: "tagAlong.commonStock",
                        label: "A\xe7\xf5es ON",
                        accessibilityLabels: [
                            "Tag Along m\xednimo das A\xe7\xf5es Ordin\xe1rias",
                            "Tag Along m\xe1ximo das A\xe7\xf5es Ordin\xe1rias"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedSliderRange, {
                        attribute: "tagAlong.preferredStock",
                        label: "A\xe7\xf5es PN",
                        accessibilityLabels: [
                            "Tag Along m\xednimo das A\xe7\xf5es Preferenciais",
                            "Tag Along m\xe1ximo das A\xe7\xf5es Preferenciais"
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/index.ts
















;// CONCATENATED MODULE: ./components/screener/refinements/Country.tsx









var CountryRefinementList = (0,connectRefinementList/* default */.Z)(function(param) {
    var isChoosingCountry = param.isChoosingCountry, onToggleChooseCountry = param.onToggleChooseCountry, items = param.items, refine = param.refine;
    var options = orderBy_default()([
        "isRefined",
        "count",
        "label"
    ], [
        "desc",
        "desc",
        "asc"
    ], items);
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var pagination = useInfinitePagination({
        itemsPerPage: 10,
        items: options.filter(function(item) {
            if (searchQuery && searchQuery.trim()) {
                var cleanSearchQuery = searchQuery.trim();
                return deburr_default()(item.label).toLowerCase().includes(deburr_default()(cleanSearchQuery).toLowerCase());
            }
            return true;
        })
    });
    (0,react.useEffect)(function() {
        if (searchQuery !== "") {
            pagination.reset();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    var refinements = items.filter(function(item) {
        return item.isRefined;
    });
    if (!isChoosingCountry) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "space-y-1",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                            className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                            children: "Pa\xeds"
                        }),
                        refinements.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex items-center space-x-1",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "font-aeonik text-sm font-medium italic tracking-wide text-slate-500",
                                    children: "Filtrando por"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                    className: "rounded-xl border border-violet-300 bg-violet-50 px-2 py-0.5 text-xs font-bold text-violet-700",
                                    children: [
                                        refinements.length,
                                        " ",
                                        refinements.length === 1 ? "pa\xeds" : "pa\xedses"
                                    ]
                                })
                            ]
                        }),
                        refinements.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                                children: "Filtre empresas por pa\xeds."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "button",
                    className: "font-aeonik text-sm font-medium tracking-wide text-blue-600 hover:underline disabled:text-slate-400",
                    onClick: function() {
                        return onToggleChooseCountry(true);
                    },
                    disabled: items.length === 0,
                    children: refinements.length > 0 ? "Escolher outros pa\xedses (".concat(items.length, ")") : "Escolher pa\xedses (".concat(items.length, ")")
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-medium uppercase tracking-wide text-slate-500",
                        children: "Pa\xeds"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal tracking-wide text-slate-400",
                        children: "Escolha um ou v\xe1rios pa\xedses."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* MiniSearchInput */.D$, {
                value: searchQuery,
                placeholder: "Pesquisar",
                onChange: function(searchQuery) {
                    return setSearchQuery(searchQuery);
                }
            }),
            pagination.items.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggableRefinementList, {
                        items: pagination.items,
                        refine: refine
                    }),
                    pagination.hasMoreToShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            onClick: pagination.showMore,
                            className: "font-aeonik text-sm font-medium tracking-wide text-sky-600 hover:underline",
                            children: "Ver mais pa\xedses"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        variant: "faded"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            type: "button",
                            className: "font-aeonik text-sm font-medium tracking-wide text-violet-600 hover:underline",
                            onClick: function() {
                                onToggleChooseCountry(false);
                                pagination.reset();
                            },
                            children: "Ver todos os filtros"
                        })
                    })
                ]
            })
        ]
    });
});
function Country(param) {
    var isChoosingCountry = param.isChoosingCountry, onToggleChooseCountry = param.onToggleChooseCountry;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountryRefinementList, {
        isChoosingCountry: isChoosingCountry,
        onToggleChooseCountry: onToggleChooseCountry,
        attribute: "headquarters.countryName",
        limit: 120
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/CurrentRefinements.tsx


var CurrentRefinements = (0,connectCurrentRefinements/* default */.Z)(function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return children(props);
});
/* harmony default export */ var refinements_CurrentRefinements = (CurrentRefinements);

// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectToggleRefinement.js
var connectToggleRefinement = __webpack_require__(16697);
;// CONCATENATED MODULE: ./components/screener/shared/ConnectedToggle.tsx



function ConnectedToggle(param) {
    var id = param.id, name = param.name, className = param.className, label = param.label, currentRefinement = param.currentRefinement, refine = param.refine;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* Checkbox */.XZ, {
        id: id,
        name: label || name,
        className: className,
        checked: currentRefinement,
        onChange: function(isChecked) {
            return refine(isChecked);
        }
    });
}
/* harmony default export */ var shared_ConnectedToggle = ((0,connectToggleRefinement/* default */.Z)(ConnectedToggle));

;// CONCATENATED MODULE: ./components/screener/refinements/IsAmericanDepositaryReceipt.tsx


function IsAmericanDepositaryReceipt() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "font-aeonik text-base font-bold tracking-wide text-zinc-500",
                children: "ADRs"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                        children: "Filtre por Stocks que s\xe3o ADRs"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedToggle, {
                        label: "BDRs",
                        attribute: "isAmericanDepositaryReceipt",
                        value: true
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/IsBrazilianDepositaryReceipt.tsx


function IsBrazilianDepositaryReceipt() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "font-aeonik text-base font-bold tracking-wide text-zinc-500",
                children: "BDRs"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                        children: "Filtre por A\xe7\xf5es que s\xe3o BDRs"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedToggle, {
                        label: "BDRs",
                        attribute: "isBrazilianDepositaryReceipt",
                        value: true
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/screener/refinements/IsFiagro.tsx





function IsFiagro() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-2 rounded-lg border border-green-900/20 bg-green-50 p-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "flex items-start space-x-2",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold tracking-wide text-green-800",
                        children: "Fiagros"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FarmIcon, {
                        className: "h-5 w-5 fill-emerald-900"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-500",
                        children: "Filtre por FIIs do Agroneg\xf3cio"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedToggle, {
                        label: "Fiagro",
                        attribute: "isFiagro",
                        value: true
                    })
                ]
            })
        ]
    });
};
function FarmIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "m39 1.922-5.563 2.226L30 7.586V12l-2-.059V11a1.003 1.003 0 0 0-1.016-1.016c-.55.012-.992.465-.984 1.016v.922a71.358 71.358 0 0 0-3 .047V11a1.003 1.003 0 0 0-1.016-1.016c-.55.012-.992.465-.984 1.016v1.059c-1.477.078-2.8.18-4 .296V11a1.003 1.003 0 0 0-1.016-1.016c-.55.012-.992.465-.984 1.016v1.566c-1.477.18-2.617.356-3.164.45-.305.05-.547.097-.836.148v-1.762a.997.997 0 0 0-1.016-1.015A1 1 0 0 0 9 11.402v2.125c-2.32.453-3.969.868-5 1.149v-1.91a.99.99 0 0 0-.227-.817.997.997 0 0 0-.773-.351v2l-1-1V24c0 .086.012.172.031.254-.02.082-.031.164-.031.246V47c0 .55.45 1 1 1h44c.55 0 1-.45 1-1V7.586l-3.438-3.438Zm0 2.156 4.438 1.774L46 8.414v8.371c-.68-.074-1.355-.152-2-.21V11c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1v4.969c-.715-.02-1.383-.035-2-.047V8.414l2.563-2.562ZM39 6c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-3 6h6v4.398a143.26 143.26 0 0 0-6-.363Zm-6 1v2.89c-.648.005-1.32.024-2 .055v-2c.93.024 1.953.055 1.953.055Zm-5.27.918c.45-.008.844 0 1.27.004v2.144a51.107 51.107 0 0 0-3 .317v-2.414c.574-.02 1.148-.047 1.73-.051Zm-3.73.145v2.636c-1.54.27-2.844.578-4 .88v-3.216a87.796 87.796 0 0 1 4-.3Zm-6 .519v3.523c-1.414.368-2.719.727-4 1.149v-4.055c.395-.074.734-.14 1.164-.215A80.693 80.693 0 0 1 15 14.582Zm-6 .984v4.235c0 .062.004.125.016.183-.602.246-1.207.504-1.852.813-.004.004-.008.004-.012.008A32.354 32.354 0 0 0 4 22.609v-5.863c.836-.242 2.504-.683 5-1.18Zm21.734 2.325c1.028.007 2.246.05 3.582.09-3.859 2.664-8.574 6.917-13.086 12.382-2.703 3.262-5.097 6.95-6.89 10.008-1.485 2.524-2.492 4.473-3 5.629H4v-8.043c3.043-3.785 7.406-8.309 13.387-12.648h.004l.004-.004c4.53-3.348 8.968-5.72 12.62-7.399l-.003-.011c.238 0 .476-.008.722-.004Zm7.078.257c.934.051 1.79.094 2.872.18-2.899 3.164-6.27 7.363-9.239 12.25h.004C27.97 36.281 25.805 41.664 24.297 46H13.562a74.412 74.412 0 0 1 2.5-4.621c1.754-2.988 4.11-6.602 6.708-9.738v-.004c5.418-6.559 11.23-11.36 15.043-13.489Zm-12.75.004c-2.777 1.477-5.777 3.27-8.847 5.54C11.02 27.46 7.015 31.362 4 34.843v-9.785c1.035-.735 2.281-1.582 4.035-2.461h.004c.004 0 .004-.004.008-.004 2.808-1.356 5.008-1.926 8.105-2.723.004-.004.012-.004.02-.008 2.133-.597 5.043-1.332 8.89-1.71Zm18.141.387c.758.07 1.54.152 2.34.242a138.36 138.36 0 0 0-5.89 14.801l.003-.008A115.693 115.693 0 0 0 36.11 46h-9.687c1.473-4.14 3.523-9.117 6.734-14.379 3.242-5.344 7.035-9.933 10.047-13.082ZM46 22.621V46h-7.84a112.89 112.89 0 0 1 3.387-11.77v-.011A139.4 139.4 0 0 1 46 22.62Z"
        })
    }));
}

// EXTERNAL MODULE: ./components/utils/formatMoneyValue.ts
var formatMoneyValue = __webpack_require__(89922);
;// CONCATENATED MODULE: ./components/screener/shared/ConnectedMoneySliderRange.tsx







function ConnectedMoneySliderRange(param) {
    var label = param.label, accessibilityLabels = param.accessibilityLabels, refine = param.refine, currentRefinement = param.currentRefinement, min = param.min, max = param.max;
    var ref = (0,react.useState)(null), willUpdateToValues = ref[0], setWillUpdateToValues = ref[1];
    var canFilter = min !== undefined && max !== undefined && min < max;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 20
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    justifyContent: "space-between",
                    color: palette/* mariner */.Mw,
                    fontWeight: "bold",
                    fontSize: 14,
                    letterSpacing: 1
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontWeight: 700
                        },
                        children: label
                    }),
                    willUpdateToValues ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                        css: {
                            fontWeight: 700,
                            color: palette/* baliHai */.r
                        },
                        children: [
                            (0,formatMoneyValue/* default */.Z)(willUpdateToValues[0] || 0, "short"),
                            " \u2014",
                            " ",
                            (0,formatMoneyValue/* default */.Z)(willUpdateToValues[1] || 0, "short")
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                        css: {
                            fontWeight: 700
                        },
                        children: [
                            (0,formatMoneyValue/* default */.Z)(currentRefinement.min || 0, "short"),
                            " \u2014",
                            " ",
                            (0,formatMoneyValue/* default */.Z)(currentRefinement.max || 0, "short")
                        ]
                    })
                ]
            }),
            canFilter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* RangeSlider */.U2, {
                disabled: !canFilter,
                domain: [
                    min || 0,
                    max || 0
                ],
                values: [
                    currentRefinement.min || 0,
                    currentRefinement.max || 0
                ],
                labels: accessibilityLabels,
                onUpdate: setWillUpdateToValues,
                onChange: function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), min = _param[0], max = _param[1];
                    setWillUpdateToValues(null);
                    // eslint-disable-next-line no-restricted-globals
                    if (isNaN(min) || isNaN(max)) {
                        refine({
                            min: undefined,
                            max: undefined
                        });
                        return;
                    }
                    refine({
                        min: min,
                        max: max
                    });
                }
            }),
            min === undefined && max === undefined && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("small", {
                css: {
                    fontWeight: 500,
                    letterSpacing: 1,
                    color: palette/* baliHai */.r
                },
                children: "Carregando..."
            }),
            !canFilter && max !== undefined && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* RangeSlider */.U2, {
                disabled: true,
                domain: [
                    0,
                    max || 0
                ],
                values: [
                    0,
                    max || 0
                ],
                labels: accessibilityLabels,
                onUpdate: function() {
                // ...
                },
                onChange: function() {
                // ...
                }
            })
        ]
    });
}
/* harmony default export */ var shared_ConnectedMoneySliderRange = ((0,connectRange/* default */.Z)(ConnectedMoneySliderRange));

;// CONCATENATED MODULE: ./components/screener/refinements/MarketCapitalization.tsx


function MarketCapitalization() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        className: "font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500",
                        children: "Market Cap"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400",
                        children: "Filtre pelo Valor de Mercado."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ConnectedMoneySliderRange, {
                attribute: "marketCapitalization",
                label: "Market Cap",
                accessibilityLabels: [
                    "Market Cap m\xednimo",
                    "Market Cap m\xe1ximo"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectStats.js
var connectStats = __webpack_require__(89473);
;// CONCATENATED MODULE: ./components/screener/ResultsCount.tsx


/* harmony default export */ var ResultsCount = ((0,connectStats/* default */.Z)(function ResultsCount(param) {
    var nbHits = param.nbHits;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-2 whitespace-nowrap font-aeonik",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                className: "m-0 text-3xl font-bold text-slate-600",
                children: nbHits
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "text-xs font-bold uppercase tracking-wide text-slate-400",
                children: nbHits === 1 ? "Ativo encontrado" : "Ativos encontrados"
            })
        ]
    });
}));

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/StarIcon.js
var StarIcon = __webpack_require__(53901);
// EXTERNAL MODULE: ./components/shared/TextTooltip.tsx + 1 modules
var TextTooltip = __webpack_require__(3925);
// EXTERNAL MODULE: ./components/ui/classNames.ts
var classNames = __webpack_require__(8750);
;// CONCATENATED MODULE: ./components/screener/cards/CompanyCard.tsx








function CompanyCard(param) {
    var company = param.company;
    var user = (0,useSelfie/* default */.Z)();
    var linkAs = company.type === "AMERICAN_COMPANY" || company.type === "AMERICAN_REIT" ? "/us/".concat(company.tickerSymbolPrefix.toLocaleLowerCase()) : "/br/".concat(company.tickerSymbolPrefix.toLocaleLowerCase());
    var linkHref = company.type === "AMERICAN_COMPANY" || company.type === "AMERICAN_REIT" ? "/us/[tickerSymbol]" : "/br/[tickerSymbol]";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: linkHref,
        as: linkAs,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            href: linkAs,
            className: (0,classNames/* default */.Z)("flex h-full flex-col rounded-lg p-4 font-aeonik font-normal text-inherit shadow-md outline-none", "box-border select-none border-2 border-transparent bg-white no-underline dark:bg-gray-900", "hover:border-violet-600 dark:hover:border-gray-600", "focus:border-sky-500"),
            css: {
                transition: "all 60ms ease 0s"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridColumnGap: 12,
                        gridTemplateColumns: company.logoUrl ? "fit-content(100%) max-content" : "fit-content(100%)",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex flex-col space-y-1 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                    className: "overflow-hidden text-ellipsis whitespace-nowrap text-base font-bold text-slate-600 dark:text-slate-400",
                                    children: company.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "text-ellipsis whitespace-nowrap text-sm font-medium italic text-gray-500",
                                    children: company.industrySector
                                })
                            ]
                        }),
                        company.logoUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            role: "presentation",
                            src: company.logoUrl,
                            onContextMenu: function(event) {
                                return event.preventDefault();
                            },
                            onMouseDown: function(event) {
                                return event.preventDefault();
                            },
                            width: 63,
                            height: 19,
                            alt: company.name,
                            draggable: false,
                            css: {
                                objectFit: "contain",
                                objectPosition: "top right",
                                userSelect: "none",
                                height: 19
                            }
                        })
                    ]
                }),
                company.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "line-clamp-3",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            className: "text-sm font-normal tracking-wider text-slate-500",
                            children: company.description
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "mt-auto",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex w-full items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "rounded-md bg-violet-50 px-2 py-1 text-xs font-bold tracking-wider text-violet-600 dark:bg-gray-700 dark:text-gray-300",
                                    children: company.tickerSymbolPrefix
                                }),
                                user && user.isPremium && company.ratingSummary && company.ratingSummary.overallRating > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextTooltip/* default */.Z, {
                                    id: "tooltips/CompanyCard/ratingSummary/".concat(company._id),
                                    placement: "top",
                                    content: company.ratingSummary.totalRatings === 1 ? "".concat(company.ratingSummary.totalRatings, " avalia\xe7\xe3o") : "".concat(company.ratingSummary.totalRatings, " avalia\xe7\xf5es"),
                                    children: function(param) {
                                        var accessibility = param.accessibility, bind = param.bind, ref = param.ref;
                                        var ref1;
                                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            className: "flex items-center text-sm"
                                        }, accessibility, bind), {
                                            ref: ref,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarIcon/* default */.Z, {
                                                    className: "-mt-[1px] h-4 w-4 fill-amber-500 text-amber-500 dark:fill-amber-500 dark:text-amber-500"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    className: "ml-1",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                        className: "font-bold text-amber-600 dark:text-amber-600",
                                                        children: (ref1 = company.ratingSummary) === null || ref1 === void 0 ? void 0 : ref1.overallRating
                                                    })
                                                })
                                            ]
                                        }));
                                    }
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/screener/cards/RealEstateFundCard.tsx








function RealEstateFundCard(param) {
    var fund = param.fund;
    var user = (0,useSelfie/* default */.Z)();
    var linkAs = "/fiis/".concat(fund.tickerSymbolPrefix.toLocaleLowerCase());
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/fiis/[tickerSymbol]",
        as: linkAs,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            href: linkAs,
            className: (0,classNames/* default */.Z)("flex h-full flex-col rounded-lg p-4 font-aeonik font-normal text-inherit shadow-md outline-none", "box-border select-none border-2 border-transparent bg-white no-underline dark:bg-gray-900", "hover:border-violet-600 dark:hover:border-gray-600", "focus:border-sky-500"),
            css: {
                transition: "all 60ms ease 0s"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridColumnGap: 12,
                        gridTemplateColumns: fund.logoUrl ? "fit-content(100%) max-content" : "fit-content(100%)",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex flex-col space-y-1 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                    className: "overflow-hidden text-ellipsis whitespace-nowrap text-base font-bold text-slate-600 dark:text-slate-400",
                                    children: fund.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "text-ellipsis whitespace-nowrap text-sm font-medium italic text-gray-500",
                                    children: fund.administrator
                                })
                            ]
                        }),
                        fund.logoUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            role: "presentation",
                            src: fund.logoUrl,
                            onContextMenu: function(event) {
                                return event.preventDefault();
                            },
                            onMouseDown: function(event) {
                                return event.preventDefault();
                            },
                            width: 63,
                            height: 19,
                            alt: fund.name,
                            draggable: false,
                            css: {
                                objectFit: "contain",
                                objectPosition: "top right",
                                userSelect: "none",
                                height: 19
                            }
                        })
                    ]
                }),
                fund.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "line-clamp-3",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            className: "text-sm font-normal tracking-wider text-slate-500",
                            children: fund.description
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "mt-auto",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex w-full items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "rounded-md bg-violet-50 px-2 py-1 text-xs font-bold tracking-wider text-violet-600 dark:bg-gray-700 dark:text-gray-300",
                                    children: fund.tickerSymbolPrefix
                                }),
                                user && user.isPremium && fund.ratingSummary && fund.ratingSummary.overallRating > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextTooltip/* default */.Z, {
                                    id: "tooltips/CompanyCard/ratingSummary/".concat(fund._id),
                                    placement: "top",
                                    content: fund.ratingSummary.totalRatings === 1 ? "".concat(fund.ratingSummary.totalRatings, " avalia\xe7\xe3o") : "".concat(fund.ratingSummary.totalRatings, " avalia\xe7\xf5es"),
                                    children: function(param) {
                                        var accessibility = param.accessibility, bind = param.bind, ref = param.ref;
                                        var ref1;
                                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            className: "flex items-center text-sm"
                                        }, accessibility, bind), {
                                            ref: ref,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarIcon/* default */.Z, {
                                                    className: "-mt-[1px] h-4 w-4 fill-amber-500 text-amber-500 dark:fill-amber-500 dark:text-amber-500"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    className: "ml-2",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                                        className: "font-bold text-amber-600",
                                                        children: (ref1 = fund.ratingSummary) === null || ref1 === void 0 ? void 0 : ref1.overallRating
                                                    })
                                                })
                                            ]
                                        }));
                                    }
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/screener/FileSearchingDuff.tsx




function FileSearchingDuff(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 458,
        height: 424
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__a",
                        x1: "50%",
                        x2: "50%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__b",
                        x1: "50%",
                        x2: "50%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__c",
                        x1: "50%",
                        x2: "50%",
                        y1: "100%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__h",
                        x1: "0%",
                        y1: "50%",
                        y2: "50%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__i",
                        x1: ".006%",
                        x2: "100.006%",
                        y1: "50.002%",
                        y2: "50.002%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "gray",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "gray",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "gray",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__j",
                        x1: "50%",
                        x2: "50%",
                        y1: "100%",
                        y2: ".001%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopColor: "#B3B3B3",
                                stopOpacity: 0.25
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "54%",
                                stopColor: "#B3B3B3",
                                stopOpacity: 0.1
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopColor: "#B3B3B3",
                                stopOpacity: 0.05
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__k",
                        x1: "49.98%",
                        x2: "49.98%",
                        y1: "99.949%",
                        y2: "0%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "55%",
                                stopOpacity: 0.09
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopOpacity: 0.02
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__l",
                        x1: "49.989%",
                        x2: "49.989%",
                        y1: "100.006%",
                        y2: ".008%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0%",
                                stopOpacity: 0.12
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "55%",
                                stopOpacity: 0.09
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "100%",
                                stopOpacity: 0.02
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        id: "prefix__d",
                        d: "M.294.391h78.214v52.69H.294z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        id: "prefix__f",
                        d: "M.294.228h78.214v52.69H.294z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__a)",
                        fillRule: "nonzero",
                        d: "M.082.114h243.926v327.567H.082z",
                        opacity: 0.5,
                        transform: "translate(83.767 71.21)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#F2F2F2",
                        fillRule: "nonzero",
                        d: "M87.025 75.771H323.33v316.141H87.025z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        fillRule: "nonzero",
                        d: "M105.449 89.1h81.309v2.539h-81.309z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#8195EE",
                        fillRule: "nonzero",
                        d: "M105.449 100.526h81.309v2.539h-81.309z",
                        opacity: 0.7
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        fillRule: "nonzero",
                        d: "M198.827 89.1h81.309v2.539h-81.309zm12.702 72.373h81.309v2.539h-81.309zm1.909 6.98h81.309v2.539h-81.309zm3.813 6.985h81.309v2.539h-81.309zm-5.722 98.395h81.309v2.539h-81.309zm1.909 6.985h81.309v2.539h-81.309zm3.813 6.98h81.309v2.539h-81.309z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__b)",
                        fillRule: "nonzero",
                        d: "M.016.087h86.389v87.605H.016z",
                        opacity: 0.5,
                        transform: "translate(106.069 135.354)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#F5F5F5",
                        fillRule: "nonzero",
                        d: "M106.629 137.349h85.029v83.794h-85.029z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__c)",
                        fillRule: "nonzero",
                        d: "M.294.005h79.307v54.593H.294z",
                        opacity: 0.5,
                        transform: "translate(109.333 142.42)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        fillRule: "nonzero",
                        d: "M110.17 143.062h78.214v52.69H110.17z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(207.242 175.58)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                                id: "prefix__e",
                                fill: "#fff",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                    xlinkHref: "#prefix__d"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                                fill: "#6C63FF",
                                fillRule: "nonzero",
                                mask: "url(#prefix__e)",
                                opacity: 0.4,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                    transform: "translate(-106.613 -30.985)",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M2.91 49.255L22.606 18.78l8.257 13.329L48.65 13.704 63.897 32.11 77.234 4.816l34.302 54.593L.37 55.599z"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                            cx: 18.157,
                                            cy: 6.083,
                                            rx: 5.717,
                                            ry: 5.713
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__b)",
                        fillRule: "nonzero",
                        d: "M.016.473h86.389v87.605H.016z",
                        opacity: 0.5,
                        transform: "translate(106.069 247.333)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#F5F5F5",
                        fillRule: "nonzero",
                        d: "M106.629 249.709h85.029v83.794h-85.029z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__c)",
                        fillRule: "nonzero",
                        d: "M.294.391h79.307v54.593H.294z",
                        opacity: 0.5,
                        transform: "translate(109.333 254.4)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        fillRule: "nonzero",
                        d: "M110.17 255.422h78.214v52.69H110.17z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(207.242 288.103)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                                id: "prefix__g",
                                fill: "#fff",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                    xlinkHref: "#prefix__f"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                                fill: "#BDBDBD",
                                fillRule: "nonzero",
                                mask: "url(#prefix__g)",
                                opacity: 0.4,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                    transform: "translate(-106.613 -30.985)",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M2.91 49.092l19.696-30.474 8.257 13.334L48.65 13.541l15.247 18.411L77.234 4.653l34.302 54.593L.37 55.44z"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                            cx: 18.157,
                                            cy: 5.925,
                                            rx: 5.717,
                                            ry: 5.713
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__h)",
                        fillRule: "nonzero",
                        d: "M-11.698 62.657l327.576.04.03 243.92-327.575-.04z",
                        opacity: 0.5,
                        transform: "rotate(-78.76 245.11 139.525)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        fillRule: "nonzero",
                        d: "M124.135 370.196l61.662-310.078 231.773 46.03-61.662 310.078z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        fillRule: "nonzero",
                        d: "M199.8 77.775l164.487 32.668-.495 2.49-164.487-32.668zM152.998 313.14l164.486 32.666-.495 2.49-164.486-32.667zm-2.853 14.315l127.103 25.243-.495 2.49-127.103-25.244z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#8195EE",
                        fillRule: "nonzero",
                        d: "M147.298 341.78l47.35 9.404-.496 2.49-47.349-9.404zm49.65-249.681l82.24 16.333-.495 2.49-82.24-16.333z",
                        opacity: 0.7
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        fillRule: "nonzero",
                        d: "M194.107 106.418l148.283 29.45-.495 2.49-148.284-29.45z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#2F4EDA",
                        fillRule: "nonzero",
                        d: "M191.256 120.742l36.135 7.176-.495 2.49-36.135-7.176z",
                        opacity: 0.7
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        fillRule: "nonzero",
                        d: "M188.411 135.063l164.486 32.667-.495 2.49-164.486-32.667z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__i)",
                        fillRule: "nonzero",
                        d: "M39.108-17.871l86.335.01.019 150.544-86.335-.01z",
                        opacity: 0.5,
                        transform: "rotate(-78.76 294.173 41.662)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        fillRule: "nonzero",
                        d: "M203.74 196.361l145.792 28.955-16.468 82.81-145.792-28.954z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E0E0E0",
                        fillRule: "nonzero",
                        d: "M185.563 149.388l164.487 32.667-.496 2.49-164.486-32.667z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#6C63FF",
                        fillRule: "nonzero",
                        d: "M216.78 210.6l18.07 3.59-12.011 60.396-18.07-3.589z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#D1D9FA",
                        fillRule: "nonzero",
                        d: "M245.214 236.96l18.07 3.59-8.048 40.472-18.07-3.589zm28.689 25.116l18.07 3.588-4.334 21.79-18.07-3.588zm36.856-15.982l18.07 3.589-8.792 44.21-18.07-3.589z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__j)",
                        fillRule: "nonzero",
                        d: "M381.549 190.805a84.822 84.822 0 00-60.487-26.006 84.823 84.823 0 00-60.872 25.093c-32.093 32.333-32.637 84.98-1.246 117.997 28.474 29.951 74.41 35.017 108.734 11.992l61.297 63.714a4.13 4.13 0 005.837.114l15.274-14.677a4.124 4.124 0 00.114-5.833l-61.28-63.708c24.253-33.218 21.146-79.042-7.371-108.686zm-19.093 102.44c-24.146 23.199-62.54 22.443-85.753-1.687-23.215-24.13-22.46-62.499 1.686-85.698 24.145-23.2 62.538-22.447 85.754 1.683a60.589 60.589 0 0116.919 43.2 60.592 60.592 0 01-18.606 42.502z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__k)",
                        fillRule: "nonzero",
                        d: "M275.502 232.689c-6.821 0-6.832 10.595 0 10.595s6.832-10.595 0-10.595z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__l)",
                        fillRule: "nonzero",
                        d: "M323.048 198.753c-18.358-.413-35.063 8.79-43.945 22.684-2.9 4.533 5.33 8.54 8.213 4.028 7.354-11.503 21.328-18.808 36.444-18.428 15.84.397 30.254 9.453 37.886 22.02 2.894 4.768 10.482.436 7.615-4.304-9.28-15.22-27.251-25.55-46.213-26z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#3F5FE9",
                        fillRule: "nonzero",
                        d: "M388.201 187.587a84.822 84.822 0 00-60.487-26.006 84.823 84.823 0 00-60.872 25.093c-32.093 32.333-32.636 84.98-1.246 117.997 28.476 29.95 74.412 35.013 108.735 11.986l61.291 63.72a4.13 4.13 0 005.837.114l15.274-14.677a4.124 4.124 0 00.114-5.833l-61.297-63.714c24.257-33.211 21.158-79.031-7.349-108.68zM369.11 289.983c-24.147 23.199-62.54 22.444-85.754-1.687-23.214-24.13-22.46-62.498 1.686-85.698 24.146-23.2 62.539-22.446 85.754 1.683a60.589 60.589 0 0116.919 43.2 60.592 60.592 0 01-18.605 42.502z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#6C63FF",
                        fillRule: "nonzero",
                        d: "M282.154 229.466c-6.82 0-6.832 10.594 0 10.594s6.832-10.594 0-10.594zm47.546-33.931c-18.358-.413-35.062 8.79-43.945 22.684-2.9 4.533 5.33 8.54 8.214 4.028 7.354-11.503 21.328-18.809 36.444-18.428 15.84.397 30.254 9.453 37.885 22.02 2.894 4.768 10.482.436 7.616-4.304-9.296-15.264-27.247-25.593-46.214-26z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#BFCCDA",
                        fillRule: "nonzero",
                        d: "M66.062 361.438h1.904v10.79h-1.904z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#BFCCDA",
                        fillRule: "nonzero",
                        d: "M72.415 365.88v1.902H61.618v-1.903zM311.065 4.865a2.332 2.332 0 01-1.3-2.821 1.169 1.169 0 00-2.056-1.038 1.12 1.12 0 00-.131.228 2.334 2.334 0 01-2.823 1.3 1.17 1.17 0 00-1.028 2.066v-.001c.07.052.147.096.228.13a2.332 2.332 0 011.3 2.821 1.169 1.169 0 002.072 1.027 1.12 1.12 0 00.131-.227 2.334 2.334 0 012.823-1.3 1.17 1.17 0 001.039-2.055 1.12 1.12 0 00-.255-.13zM74.76 84.854a2.332 2.332 0 01-1.3-2.82 1.169 1.169 0 00-2.056-1.038v-.001a1.12 1.12 0 00-.131.228 2.334 2.334 0 01-2.823 1.3 1.17 1.17 0 00-1.039 2.055c.07.051.147.095.228.13a2.332 2.332 0 011.3 2.82 1.169 1.169 0 002.056 1.038v.001a1.12 1.12 0 00.131-.228 2.334 2.334 0 012.823-1.3 1.17 1.17 0 001.039-2.055 1.12 1.12 0 00-.228-.13zm336.037 330.101a2.332 2.332 0 01-1.3-2.822 1.169 1.169 0 00-2.056-1.038 1.12 1.12 0 00-.131.228 2.334 2.334 0 01-2.823 1.3 1.17 1.17 0 00-1.039 2.055c.07.052.147.096.228.13a2.332 2.332 0 011.3 2.821 1.169 1.169 0 002.056 1.038 1.12 1.12 0 00.131-.228 2.334 2.334 0 012.823-1.3 1.17 1.17 0 001.039-2.055v.001a1.12 1.12 0 00-.228-.13z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        cx: 174.687,
                        cy: 41.492,
                        fill: "#BFCCDA",
                        fillRule: "nonzero",
                        rx: 3.813,
                        ry: 3.811
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        cx: 447.834,
                        cy: 89.1,
                        fill: "#BFCCDA",
                        fillRule: "nonzero",
                        rx: 3.813,
                        ry: 3.811
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        cx: 426.239,
                        cy: 202.732,
                        fill: "#BFCCDA",
                        fillRule: "nonzero",
                        rx: 3.813,
                        ry: 3.811
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        cx: 3.813,
                        cy: 16.096,
                        fill: "#BFCCDA",
                        fillRule: "nonzero",
                        opacity: 0.5,
                        rx: 3.813,
                        ry: 3.811
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectInfiniteHits.js
var connectInfiniteHits = __webpack_require__(66658);
;// CONCATENATED MODULE: ./components/screener/ScreenerHits.tsx





var ScreenerHits = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var hits = param.hits, hasMore = param.hasMore, refineNext = param.refineNext;
    var assets = hits.filter(Boolean);
    if (assets.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex flex-col items-center justify-between space-y-10 font-aeonik",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileSearchingDuff, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "space-y-1 text-center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                            className: "text-xl font-medium tracking-wider text-slate-700",
                            children: "N\xe3o encontramos nenhum resultado."
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            className: "text-sm font-normal tracking-wider text-slate-500",
                            children: "Altere os filtros da sua busca e tente novamente."
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "space-y-7",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "relative grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3",
                children: assets.map(function(asset) {
                    if (asset.type === "BRAZILIAN_COMPANY" || asset.type === "AMERICAN_COMPANY" || asset.type === "AMERICAN_REIT") {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyCard, {
                            company: asset
                        }, asset.objectID);
                    }
                    if (asset.type === "BRAZILIAN_REAL_ESTATE_FUND") {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundCard, {
                            fund: asset
                        }, asset.objectID);
                    }
                    return null;
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "button",
                    onClick: function() {
                        return refineNext();
                    },
                    className: "font-aeonik text-base font-medium tracking-wide text-blue-600 hover:underline",
                    children: "Ver mais ativos"
                })
            })
        ]
    });
});
/* harmony default export */ var screener_ScreenerHits = (ScreenerHits);

// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 4 modules
var InstantSearch = __webpack_require__(31008);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/Configure.js
var Configure = __webpack_require__(704);
// EXTERNAL MODULE: ./node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(92261);
;// CONCATENATED MODULE: ./components/screener/Screener.tsx




















function Screener(_param) {
    var indexName = _param.indexName, searchClient = _param.searchClient, searchState = _param.searchState, props = (0,_object_without_properties/* default */.Z)(_param, [
        "indexName",
        "searchClient",
        "searchState"
    ]);
    var ref = (0,react.useState)(false), isShowingFilters = ref[0], setIsShowingFilters = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstantSearch/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        indexName: indexName,
        searchClient: searchClient,
        searchState: searchState
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(refinements_CurrentRefinements, {
            children: function(param) {
                var items = param.items;
                var filterByAssetType = getFilterByAssetType(searchState, items);
                var isChoosingSectors = hasAppliedRefinement(searchState, items, "industrySector");
                var isChoosingCountry = hasAppliedRefinement(searchState, items, "headquarters.countryName");
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: isChoosingSectors,
                    children: function(param) {
                        var isChoosingSectors = param.value, setChoosingSectors = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                            initial: isChoosingCountry,
                            children: function(param) {
                                var isChoosingCountry = param.value, setChoosingCountry = param.set;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "my-0 mx-auto grid max-w-7xl grid-cols-1 gap-7 px-6 py-6 lg:grid-cols-12 lg:py-10 lg:px-0",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "col-span-12 box-border w-full lg:col-span-3",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                className: "space-y-6",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Configure/* default */.Z, {
                                                        maxValuesPerFacet: 20,
                                                        hitsPerPage: 3 * 8
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        className: "flex flex-col space-y-4 lg:flex-row lg:justify-between lg:space-y-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResultsCount, {}),
                                                            filterByAssetType && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                className: "hidden lg:block",
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(refinements_ClearAllFilters, {})
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        className: "relative space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AssetType, {}),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                                type: "button",
                                                                className: (0,tw_merge/* twMerge */.m)("bg-purple-50 font-aeonik text-xs font-bold uppercase tracking-wider text-purple-700", "hover:bg-purple-500 hover:text-white", "w-full rounded-xl border border-purple-900/20 p-4", "lg:hidden lg:w-auto lg:rounded-full lg:border-transparent lg:px-3 lg:py-1", "focus:outline-none focus:ring-2 focus:ring-purple-200 focus:ring-offset-0", (0,clsx_m/* default */.Z)({
                                                                    hidden: items.length === 0,
                                                                    "md:hidden": items.length === 0
                                                                })),
                                                                onClick: function() {
                                                                    return setIsShowingFilters(!isShowingFilters);
                                                                },
                                                                children: isShowingFilters ? "Esconder filtros" : "Ver outros filtros dispon\xedveis"
                                                            }),
                                                            filterByAssetType && items.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                className: "flex lg:hidden",
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(refinements_ClearAllFilters, {})
                                                            }),
                                                            filterByAssetType && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                className: (0,tw_merge/* twMerge */.m)("md:block", (0,clsx_m/* default */.Z)({
                                                                    hidden: !isShowingFilters || items.length === 0,
                                                                    "md:hidden": !isShowingFilters || items.length === 0
                                                                }), "space-y-6 rounded-md border border-slate-600/20 bg-slate-50 p-6", "border-slate-200", "lg:block lg:border-transparent lg:bg-transparent lg:p-0 lg:shadow-none"),
                                                                children: [
                                                                    filterByAssetType === "BRAZILIAN_REAL_ESTATE_FUND" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsFiagro, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundAudience, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundManagement, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundMandate, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundOperatingSegment, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketCapitalization, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundClassification, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundAdministrator, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealEstateFundManager, {})
                                                                        ]
                                                                    }),
                                                                    (filterByAssetType === "AMERICAN_COMPANY" || filterByAssetType === "AMERICAN_REIT") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsAmericanDepositaryReceipt, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                                className: (0,clsx_m/* default */.Z)({
                                                                                    hidden: isChoosingCountry
                                                                                }),
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndustrySector, {
                                                                                    isChoosingSectors: isChoosingSectors,
                                                                                    onToggleChooseSectors: setChoosingSectors
                                                                                })
                                                                            }),
                                                                            !isChoosingSectors && !isChoosingCountry && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                                className: (0,clsx_m/* default */.Z)({
                                                                                    hidden: isChoosingSectors
                                                                                }),
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Country, {
                                                                                    isChoosingCountry: isChoosingCountry,
                                                                                    onToggleChooseCountry: setChoosingCountry
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                                className: (0,clsx_m/* default */.Z)("space-y-6", {
                                                                                    hidden: isChoosingSectors || isChoosingCountry
                                                                                }),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketCapitalization, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NetMargin, {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    filterByAssetType === "BRAZILIAN_COMPANY" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsBrazilianDepositaryReceipt, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndustrySector, {
                                                                                isChoosingSectors: isChoosingSectors,
                                                                                onToggleChooseSectors: setChoosingSectors
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                                className: (0,clsx_m/* default */.Z)("space-y-6", {
                                                                                    hidden: isChoosingSectors
                                                                                }),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NetMargin, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListingSegment, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketCapitalization, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeFloat, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagAlong, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentOwnership, {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "col-span-12 box-border w-full lg:col-span-9",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(screener_ScreenerHits, {})
                                        })
                                    ]
                                });
                            }
                        });
                    }
                });
            }
        })
    }));
}
/* harmony default export */ var screener_Screener = (Screener);
function hasAppliedRefinement(searchState, refinements, forAttribute) {
    return refinements.some(function(param) {
        var attribute = param.attribute;
        return attribute === forAttribute;
    }) || searchState && searchState.refinementList && searchState.refinementList[forAttribute] && Array.isArray(searchState.refinementList[forAttribute]) && searchState.refinementList[forAttribute].length > 0;
}
function getFilterByAssetType(searchState, refinements) {
    var match = refinements.find(function(param) {
        var attribute = param.attribute;
        return attribute === "type";
    });
    var filterByAssetType = null;
    if (match) {
        filterByAssetType = Array.isArray(match.currentRefinement) ? match.currentRefinement[0] : match.currentRefinement;
    }
    if (filterByAssetType === null && searchState && searchState.menu && searchState.menu.type) {
        filterByAssetType = searchState.menu.type;
    }
    return filterByAssetType;
}

// EXTERNAL MODULE: ./components/screener/searchState.ts + 14 modules
var screener_searchState = __webpack_require__(38290);
// EXTERNAL MODULE: ./components/shared/TwoPassRender.tsx
var TwoPassRender = __webpack_require__(95773);
// EXTERNAL MODULE: ./components/shared/WholePageLoadingBlankslate.tsx
var WholePageLoadingBlankslate = __webpack_require__(14501);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isWithinInterval/index.js
var isWithinInterval = __webpack_require__(24257);
// EXTERNAL MODULE: ./lib/algolia/indexes.ts
var indexes = __webpack_require__(98806);
// EXTERNAL MODULE: ./lib/algolia/searchClient.ts
var searchClient = __webpack_require__(17615);
// EXTERNAL MODULE: ./lib/algolia/SearchStateContext.tsx
var SearchStateContext = __webpack_require__(64869);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/server.js
var server = __webpack_require__(20065);
;// CONCATENATED MODULE: ./pages/index.tsx




/* eslint-disable react/no-unstable-nested-components */ 

















var Index = function Index(param) {
    var indexName = param.indexName, resultsState = param.resultsState;
    var ref = (0,react.useContext)(Auth/* AuthContext */.Vo), user = ref.user, loading = ref.loading;
    if (loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WholePageLoadingBlankslate/* default */.Z, {});
    }
    if (!user) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Landing, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: "Fundamentei"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackToTop/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverdueSubscriptionStickyBanner/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CaixaPretaPopUps, {
                currentDate: new Date(),
                popUps: [
                    {
                        key: "liveComoMonteiAMinhaCarteira",
                        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h2", {
                            className: "inline-flex items-center space-x-2 rounded-md bg-black/20 p-1 px-2 font-bold leading-6 text-white md:text-xl md:leading-normal",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: "Live | Como Montei a Minha Carteira"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    className: "relative flex h-2 w-2 md:h-3 md:w-3",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: "absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-80"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: "relative inline-flex h-2 w-2 rounded-full bg-red-500 md:h-3 md:w-3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        popUpContent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            children: [
                                "Fala Investidor! Gostaria de te convidar para uma Live in\xe9dita na pr\xf3xima segunda, dia",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                    className: "inline-block rounded-md bg-black/50 p-1 px-2 text-xs text-white",
                                    children: "01/08 \xe0s 20h"
                                }),
                                " ",
                                "no Youtube, sobre como montei a minha carteira de Renda Vari\xe1vel, est\xe1 imperd\xedvel! \uD83D\uDE09"
                            ]
                        }),
                        externalLinkText: "Definir Lembrete",
                        externalLinkHref: "https://www.youtube.com/watch?v=ZdRIJtPVAa0",
                        period: [
                            (0,parseISO/* default */.Z)("2022-07-26T22:00:00"),
                            (0,parseISO/* default */.Z)("2022-08-01T22:00:00")
                        ],
                        rootClassName: "bg-gradient-to-r from-[#3f5fe9] to-red-500/90"
                    },
                    {
                        key: "caixaPretaInscri\xe7\xf5esAbertas",
                        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h2", {
                            className: "inline-flex items-center space-x-2 rounded-md bg-black/20 p-1 px-2 font-bold leading-6 text-white md:text-xl md:leading-normal",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: "Caixa Preta | Inscri\xe7\xf5es Abertas"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "inline-flex animate-pulse",
                                    children: "\uD83D\uDD25"
                                })
                            ]
                        }),
                        popUpContent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            children: "Quer descobrir cada a\xe7\xe3o, FII, Stock e REIT que comp\xf5e a minha carteira e se sentir mais seguro com a escolha dos seus ativos? Ent\xe3o garanta j\xe1 a sua vaga no Caixa Preta Fundamentei!"
                        }),
                        externalLinkText: "Ver mais detalhes",
                        externalLinkHref: "https://hotm.art/YJqEjC6V",
                        period: [
                            (0,parseISO/* default */.Z)("2022-08-01T22:00:01"),
                            (0,parseISO/* default */.Z)("2022-08-04T23:59:59")
                        ],
                        rootClassName: "bg-gradient-to-r from-black/70 to-orange-400/100"
                    },
                    {
                        key: "caixaPreta\xdaltimosDias",
                        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h2", {
                            className: "inline-flex items-center space-x-2 rounded-md bg-black/20 p-1 px-2 font-bold leading-6 text-white md:text-xl md:leading-normal",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: "Caixa Preta | \xdaltimos Dias"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "inline-flex animate-pulse",
                                    children: "\u26A0\uFE0F"
                                })
                            ]
                        }),
                        popUpContent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            children: "\xdaltimos dias para voc\xea descobrir cada a\xe7\xe3o, FII, Stock e REIT que comp\xf5e a minha carteira de renda vari\xe1vel e se sentir mais seguro com a escolha dos seus ativos... Corre que t\xe1 acabando!"
                        }),
                        externalLinkText: "Quero a minha vaga!",
                        externalLinkHref: "https://hotm.art/YJqEjC6V",
                        period: [
                            (0,parseISO/* default */.Z)("2022-08-05T00:00:00"),
                            (0,parseISO/* default */.Z)("2022-08-07T22:00:00")
                        ],
                        rootClassName: "bg-gradient-to-r from-black/70 to-red-500/100"
                    },
                    {
                        key: "blackFridayCaixaPretaComDesconto",
                        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                            className: "inline-flex items-center space-x-2 rounded-md bg-orange-600 p-1 px-2 font-bold leading-6 text-white md:text-xl md:leading-normal",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                children: [
                                    "Black Friday Caixa Preta ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        className: "underline",
                                        children: "com desconto"
                                    }),
                                    "!"
                                ]
                            })
                        }),
                        popUpContent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            children: [
                                "Quer descobrir cada A\xe7\xe3o, FII, Stock e REIT que comp\xf5e a minha carteira? Ent\xe3o garanta j\xe1 a sua vaga com 25% de desconto no Caixa Preta Fundamentei! ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                    children: "Esse valor nunca mais vai se repetir"
                                }),
                                "..."
                            ]
                        }),
                        externalLinkText: "Quero a minha vaga!",
                        externalLinkHref: "https://hotm.art/YJqEjC6V",
                        period: [
                            (0,parseISO/* default */.Z)("2022-11-25T22:00:00"),
                            (0,parseISO/* default */.Z)("2022-11-27T22:00:00")
                        ],
                        rootClassName: "bg-gradient-to-r from-black/50 to-black/100"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchStateContext/* SearchStateConsumer */.CE, {
                children: function(param) {
                    var searchState = param.searchState, setSearchState = param.setSearchState;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(screener_Screener, {
                        searchClient: searchClient/* default */.Z,
                        indexName: indexName,
                        searchState: searchState,
                        resultsState: resultsState,
                        onSearchStateChange: setSearchState
                    });
                }
            })
        ]
    });
};
Index.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var query, indexName, searchState, resultsState;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    query = param.query;
                    indexName = indexes/* default.issuers */.Z.issuers;
                    searchState = (0,screener_searchState/* getInitialSearchStateFromQuery */.O6)(query);
                    _ctx.next = 5;
                    return (0,server.findResultsState)(screener_Screener, {
                        searchClient: searchClient/* default */.Z,
                        indexName: indexName,
                        searchState: searchState
                    });
                case 5:
                    resultsState = _ctx.sent;
                    return _ctx.abrupt("return", {
                        indexName: indexName,
                        resultsState: resultsState
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var pages = (Index);
var CAIXA_PRETA_POPUPS_KEY = "@fundamentei/caixaPretaPopUps";
function CaixaPretaPopUps(param) {
    var currentDate = param.currentDate, popUps = param.popUps;
    var ref = (0,react.useState)(function() {
        if (typeof localStorage !== "undefined") {
            var caixaPretaPopUps = localStorage.getItem(CAIXA_PRETA_POPUPS_KEY);
            if (!caixaPretaPopUps) {
                return [];
            }
            try {
                return JSON.parse(caixaPretaPopUps) || [];
            } catch (e) {
                return [];
            }
        }
        return [];
    }), closedPopUps = ref[0], setClosedPopUps = ref[1];
    var popUp = popUps.find(function(param) {
        var period = param.period;
        var _period = (0,_sliced_to_array/* default */.Z)(period, 2), start = _period[0], end = _period[1];
        return (0,isWithinInterval/* default */.Z)(currentDate, {
            start: start,
            end: end
        });
    });
    if (!popUp) {
        return null;
    }
    var hasClosedPopUp = closedPopUps.includes(popUp.key);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwoPassRender/* default */.Z, {
        children: function() {
            if (hasClosedPopUp) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "m-auto mt-8 mb-0 max-w-[1140px] space-y-8",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WorkshopCaixaPretaFundamentei, {
                    popUpTitle: popUp.title,
                    className: popUp.rootClassName,
                    externalLinkText: popUp.externalLinkText,
                    externalLinkHref: popUp.externalLinkHref,
                    onClose: function() {
                        setClosedPopUps(function(closedPopUps) {
                            var nextClosedPopUps = (0,lodash.uniq)(closedPopUps.concat(popUp.key));
                            localStorage.setItem(CAIXA_PRETA_POPUPS_KEY, JSON.stringify(nextClosedPopUps));
                            return nextClosedPopUps;
                        });
                    },
                    children: popUp.popUpContent
                })
            });
        }
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,5063,4164,3140,8538,2077,4201,1019,6092,4556,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);